/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
import React, { useEffect } from "react";

// import clsx from 'clsx';
import { makeStyles } from "@mui/styles";
import {
  Autocomplete,
  Box,
  Button,
  Card,
  Checkbox,
  Collapse,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import FeatherIcon from "feather-icons-react";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import ptLocale from "date-fns/locale/pt";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import Instance from "../../../../../utils/Axios";
import BASE_URL from "../../../../../utils/BASE_URL";
import fileDownload from "js-file-download";
import MultipleDatesPicker from "@ambiot/material-ui-multiple-dates-picker";

//ACTIONS
import EditCredenciacao from "../../../../../utils/redux/actions/aprovisionamento/credenciacoes/EditCredenciacaoAction";
import GetCredFuncionarios from "../../../../../utils/redux/actions/aprovisionamento/credenciacoes/GetCredFuncionariosAction";
import GetCredCopiaCredenciacaoUploaded from "../../../../../utils/redux/actions/aprovisionamento/credenciacoes/GetCredCopiaCredenciacaoUploadedAction";
import ShowNotification from "../../../../../utils/redux/actions/global/notifications/NotificationAction";
import ModalRascunho from "./modalRascunho";
import GetCredAcompanhanteById from "../../../../../utils/redux/actions/aprovisionamento/credenciacoes/GetCredAcompanhanteByIdAction";
import NotifyCredenciacoes from "../../../../../utils/redux/actions/aprovisionamento/credenciacoes/NotifyCredenciacoesActions";
import GetCredAcompanhantesDisponibilidade from "../../../../../utils/redux/actions/aprovisionamento/credenciacoes/GetCredAcompanhantesDisponibilidadeAction";

const useStyles = makeStyles({
  list: {
    width: "80vw",
    borderRadius: "10px 0px 0px 10px !important",
    // background: 'red !important',
  },
  fullList: {
    width: "auto",
  },
  paper: {
    background: "#FAFAFA",
  },
  btnGuardar: {
    color: "white",
    width: "120px",
    height: "40px",
    // borderRadius: '15px',
    backgroundColor: "#E21450",
    border: `1px solid #E21450`,
    display: "flex",
    alignItems: "center",
    transition: "0.2s",
    "&:hover": {
      backgroundColor: "#bc1041",
      border: "1px solid #bc1041",
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "#bc1041",
      },
      "&:disabled": {
        backgroundColor: "#bc1041",
      },
    },
  },
  btnCloseDrawer: {
    color: "#464255",
    width: "30px",
    height: "40px",
    borderRadius: "15px",
    backgroundColor: "#f2f2f2",
    border: `1px solid #f2f2f2`,
    display: "flex",
    alignItems: "center",
    transition: "0.2s",
    "&:hover": {
      backgroundColor: "#e0e0e0",
      border: "1px solid #e0e0e0",
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "#e0e0e0",
      },
    },
  },
  drawerHeader: {
    display: "flex",
    justifyContent: "space-between",
  },

  noBorder: {
    border: "none",
  },
  btnFiltrar: {
    color: "#E21450",
    width: "115px",
    height: "40px",
    fontWeight: "bold",
    // borderRadius: '15px',
    backgroundColor: "white",
    border: `1px solid #707070`,
    display: "flex",
    alignItems: "center",
    transition: "0.2s",
    "&:hover": {
      backgroundColor: "#ECECEC",
      border: "1px solid #707070",
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "#F7F7F7 ",
      },
    },
  },
  btnTrue: {
    display: "inline-block",
    width: "100%",
    height: 40,
    border: "1px solid lightgrey",
    borderRadius: "5px",
    background: "white",
    "&:focus": {
      background: "white",
    },
    "&:hover": {
      backgroundColor: "lightgrey",
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "lightgrey",
      },
    },
  },
  btnFalse: {
    display: "inline-block",
    width: "100%",
    height: 40,
    border: "1px solid lightgrey",
    borderRadius: "5px",
    background: "lightgrey",
    "&:focus": {
      background: "lightgrey",
    },
    "&:hover": {
      backgroundColor: "lightgrey",
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "lightgrey",
      },
    },
  },
  btnUpload: {
    color: "#E21450",
    // width: '125px',
    height: "40px",
    fontWeight: "bold",
    // borderRadius: '15px',
    backgroundColor: "white",
    border: `1px solid #707070`,
    display: "flex",
    alignItems: "center",
    transition: "0.2s",
    "&:hover": {
      backgroundColor: "#ECECEC",
      border: "1px solid #707070",
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "#F7F7F7 ",
      },
    },
  },
  blurredText: {
    color: "transparent", // Make the text transparent
    textShadow: "0 0 10px #000", // Apply a text shadow to create the blur effect
    userSelect: "none", // Prevent text selection
  },
  disabledTextField: {
    opacity: 0.7,
    pointerEvents: "none",
    userSelect: "none", // Adjust opacity to indicate the disabled state
    "& .MuiInputBase-input.Mui-disabled": {
      WebkitTextFillColor: "transparent",
    },
  },
  textField: {
    userSelect: "none",
  },
});

const FormEditPontual = ({
  toggleDrawer,
  drawerWidth,
  dimensions,
  credenciacaoId,
  credenciacao,
  setCredenciacao,
  fetchCredenciacoes,
  funcoes,
  tipoCartoes,
  tipoVinculos,
  cores,
  funcionarios,
  acompanhantes,
  motivos,
  estados,
  empresas,
  habilitacoes,
  tipoDocs,
  inqPessoal,
  copCred,
  tipoCredenciacao,
  tipoCombustiveis,
  tipoVeiculos,
  portariaAcesso,
  veiculos,
  obrasState,
  destinatariosOptions,
  globalFetch,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  dayjs.extend(advancedFormat);

  const today = new Date();

  const ficheirosState = useSelector((state) => state.credenciais.ficheiros);

  const ficheirosViaturasState = useSelector(
    (state) => state.credenciais.ficheirosViaturas
  );
  const downloadFiles = useSelector((state) => state.credenciais.downloadFiles);
  const acompanhantesDisponibilidade = useSelector(
    (state) => state.credenciais.acompanhantesDisponibilidade
  );

  const filteredAcompanhantes = acompanhantes.filter((acompanhante) => {
    // Check if there's no record in acompanhados array with acompanhados >= 6 for the current acompanhante
    return !acompanhantesDisponibilidade.some(
      (a) => a.id === acompanhante.id && a.acompanhados >= 6
    );
  });

  const user = useSelector((state) => state.user.perfilId);
  const permissoes = useSelector((state) => state.user.permissoes);
  const superuser = permissoes.includes("APP_CRED_SUPER_USER");

  function checkConsecutiveDates(aero, selectedDates) {
    // Define the max consecutive days allowed based on the consecutiveLimit value
    const maxConsecutiveDays = aero === 1313 ? 3 : 5;

    // Ensure dates are sorted
    const sortedDates = selectedDates.sort((a, b) => new Date(a) - new Date(b));

    let consecutiveCount = 1; // Start counting from 1 because we have at least one date

    // Iterate through the dates and check for consecutive days
    for (let i = 1; i < sortedDates.length; i++) {
      const previousDate = new Date(sortedDates[i - 1]);
      const currentDate = new Date(sortedDates[i]);

      // Calculate the difference in days
      const diffInDays = (currentDate - previousDate) / (1000 * 60 * 60 * 24);

      if (diffInDays === 1) {
        // If consecutive, increment the counter
        consecutiveCount++;
        if (consecutiveCount > maxConsecutiveDays) {
          // If more than 3 consecutive days are found, return false
          return false;
        }
      } else {
        // Reset the counter if dates are not consecutive
        consecutiveCount = 1;
      }
    }

    // If no more than 3 consecutive days were found, return true
    return true;
  }

  // ############################################################## //
  // #########################  Collapse  ######################### //
  // ############################################################## //

  const [open, setOpen] = useState(false);

  // ############################################################## //
  // ######################  Autocompletes  ####################### //
  // ############################################################## //

  const [funcionario, setFuncionario] = useState({ id: null, nome: "" });
  const [funcionarioSel, setFuncionarioSel] = useState({});
  const [veiculo, setVeiculo] = useState({ id: null, descricao: "" });
  const [estado, setEstado] = useState({ id: null, descricao: "" });
  const [projeto, setProjeto] = useState({ id: null, descricao: "" });
  const [aeroporto, setAeroporto] = useState({
    id: "0",
    descricao: "",
  });
  const [funcao, setFuncao] = useState({
    id: "0",
    descricao: "",
  });
  const [acompanhante, setAcompanhante] = useState({
    id: null,
    nome: "",
    aeroporto: "",
    numero: "",
  });
  const [motivo, setMotivo] = useState({
    id: null,
    descricao: "",
  });
  const [tipoCartao, setTipoCartao] = useState({
    id: "0",
    descricao: "",
  });
  const [tipoVinculo, setTipoVinculo] = useState({
    id: "0",
    descricao: "",
  });
  const [tipoCombustivel, setTipoCombustivel] = useState({
    id: null,
    descricao: "",
  });
  const [tipoVeiculo, setTipoVeiculo] = useState({
    id: null,
    descricao: "",
  });
  const [portAcesso, setPortAcesso] = useState({
    id: null,
    descricao: "",
  });
  const [cor, setCor] = useState({
    id: "0",
    descricao: "",
  });
  const uploadedFiles = useSelector((state) => state.credenciais.uploadedFiles);
  const uploadedCopia = uploadedFiles.find(
    (copia) => copia.id_crede_elementos_files_tipos == 8
  );
  const uploadedCopiaExterna = uploadedFiles.find(
    (copia) => copia.id_crede_elementos_files_tipos == 23
  );
  const aeroportos = useSelector(
    (state) => state.credenciais.aeroportosByFuncId
  );
  const [destinatarios, setDestinatarios] = useState([]);

  const filterOptions = (options, { inputValue }) => {
    return options.filter(
      (option) =>
        option.descricao.toLowerCase().includes(inputValue.toLowerCase()) ||
        option.email.toLowerCase().includes(inputValue.toLowerCase())
    );
  };

  // ############################################################## //
  // #################  Dates And Time Changes  ################### //
  // ############################################################## //

  const [acessoInicial, setAcessoInicial] = useState(null);
  const [acessoFinal, setAcessoFinal] = useState(null);
  const [horasInicial, setHorasInicial] = useState(dayjs());
  const [horasFinal, setHorasFinal] = useState(dayjs());
  const [vinculoInicial, setVinculoInicial] = useState(null);
  const [vinculoFinal, setVinculoFinal] = useState(null);

  const handleAcessoInicialChange = (date) => {
    setAcessoInicial(date);
  };

  const handleAcessoFinalChange = (date) => {
    setAcessoFinal(date);
  };

  const handleHorasInicialChange = (hour) => {
    setHorasInicial(hour);
  };

  const handleHorasFinalChange = (hour) => {
    setHorasFinal(hour);
  };

  const handleVinculoInicialChange = (date) => {
    setVinculoInicial(date);
  };

  const handleVinculoFinalChange = (date) => {
    setVinculoFinal(date);
  };

  // ############################################################## //
  // ##########################  States  ########################## //
  // ############################################################## //

  const [areaA, setAreaA] = useState(false);
  const [areaB, setAreaB] = useState(false);
  const [areaC, setAreaC] = useState(false);
  const [areaE, setAreaE] = useState(false);
  const [areaI, setAreaI] = useState(false);
  const [areaL, setAreaL] = useState(false);
  const [areaM, setAreaM] = useState(false);
  const [areaO, setAreaO] = useState(false);
  const [areaP, setAreaP] = useState(false);
  const [areaT, setAreaT] = useState(false);
  const [renovacao, setRenovacao] = useState(false);
  const [pedido, setPedido] = useState(false);
  const [alteracao, setAlteracao] = useState(false);
  const [inquerito, setInquerito] = useState(false);
  const [checkIn, setCheckIn] = useState(false);
  const [portaEm, setPortaEm] = useState(false);
  const [portaDes, setPortaDes] = useState(false);
  const [outrasPortas, setOutrasPortas] = useState(false);
  const [tools, setTools] = useState(false);
  const [carAccess, setCarAccess] = useState(false);

  // ############################################################## //
  // ######################  Autocompletes  ####################### //
  // ############################################################## //

  const [vitalicio, setVitalicio] = useState(false);
  const [empresa, setEmpresa] = useState({
    id: "0",
    descricao: "",
  });
  const [habilitacao, setHabilitacao] = useState({
    id: "0",
    descricao: "",
  });
  const [tipoDoc, setTipoDoc] = useState({
    id: "0",
    descricao: "",
  });

  // ############################################################## //
  // ######################  Date Changes  ######################## //
  // ############################################################## //

  const [dataNascimento, setDataNascimento] = useState(null);
  const [dataValidade, setDataValidade] = useState(null);
  const [dataEmissao, setDataEmissao] = useState(null);

  const [openDates, setOpenDates] = useState(false);

  const [datasSelected, setDatasSelected] = useState([]);

  const handleDatesChange = (dates) => {
    setDatasSelected(dates);
  };

  const handleDataNascimentoChange = (date) => {
    setDataNascimento(date);
  };

  const handleDataValidadeChange = (date) => {
    setDataValidade(date);
  };

  const handleDataEmissaoChange = (date) => {
    setDataEmissao(date);
  };

  // ############################################################## //
  // ####################  Inquérito Pessoal  ##################### //
  // ############################################################## //

  const [inqueritoPessoal, setInqueritoPessoal] = useState([]);

  const handleInqPessoalChange = (e, inq) => {
    const file = e.target.files[0];
    console.log(file);

    setInqueritoPessoal(() => {
      const updatedFicheiros = [];
      updatedFicheiros.push({
        file,
        idTipo: inq.id_crede_elementos_files_tipos,
        path: inq.crede_elementos_files_tipos_path,
      });
      return updatedFicheiros;
    });
  };

  const handleRemoveInquerito = (e, filName) => {
    e.preventDefault();

    setInqueritoPessoal(
      inqueritoPessoal.filter(function (inqueritoPessoal) {
        return inqueritoPessoal.name !== filName.name;
      })
    );
  };
  // const [inqueritoList, setInqueritoList] = useState([]);

  // const handleInqueritoChange = (e, index, inqueritoPessoal) => {
  //   const updatedInqueritoList = [...inqueritoList];
  //   const file = e.target.files[0];

  //   // Update the specific inquerito item in the list with the new file
  //   updatedInqueritoList[index] = {
  //     ...updatedInqueritoList[index],
  //     file,
  //     idTipo: inqueritoPessoal.id_crede_elementos_files_tipos,
  //     path: inqueritoPessoal.crede_elementos_files_tipos_path,
  //   };

  //   setInqueritoList(updatedInqueritoList);
  // };

  // const handleRemoveFicheiro = (e, inquerito, index) => {
  //   e.preventDefault();

  //   setInqueritoList((prevList) => {
  //     const updatedList = [...prevList];
  //     updatedList[index] = null;
  //     return updatedList;
  //   });
  // };

  // const handleRemoveInquerito = (e, inqueritoItem) => {
  //   e.preventDefault();

  //   setInqueritoList((prevList) =>
  //     prevList.filter((item) => item !== inqueritoItem)
  //   );
  // };

  // const handleAddInquerito = () => {
  //   setInqueritoList((prevList) => [...prevList, null]);
  // };

  // ############################################################## //
  // ###################  Cópia Credenciação  ##################### //
  // ############################################################## //

  const [copiaCredenciacao, setCopiaCredenciacao] = useState([]);

  const handleCopiaChange = (e, copCred) => {
    const file = e.target.files[0];
    console.log(file);

    setCopiaCredenciacao(() => {
      const updatedFicheiros = [];
      updatedFicheiros.push({
        file,
        idTipo: copCred.id_crede_elementos_files_tipos,
        path: copCred.crede_elementos_files_tipos_path,
      });
      return updatedFicheiros;
    });
  };

  console.log(copiaCredenciacao);

  const handleRemoveCopia = (e, filName) => {
    e.preventDefault();

    setCopiaCredenciacao(
      copiaCredenciacao.filter(function (copiaCredenciacao) {
        return copiaCredenciacao.name !== filName.name;
      })
    );
  };

  // ############################################################## //
  // ####################  Cópia Credenciação  #################### //
  // ############################################################## //

  const [copiaCredenciacaoExterna, setCopiaCredenciacaoExterna] = useState([]);

  const handleCopiaExternaChange = (e, copCred) => {
    const file = e.target.files[0];
    console.log(file);

    setCopiaCredenciacaoExterna(() => {
      const updatedFicheiros = [];
      updatedFicheiros.push({
        file,
        idTipo: copCred.id_crede_elementos_files_tipos,
        path: copCred.crede_elementos_files_tipos_path,
      });
      return updatedFicheiros;
    });
  };

  const handleRemoveCopiaExterna = (e, filName) => {
    e.preventDefault();

    setCopiaCredenciacaoExterna(
      copiaCredenciacaoExterna.filter(function (copiaCredenciacaoExterna) {
        return copiaCredenciacaoExterna.name !== filName.name;
      })
    );
  };

  // ############################################################## //
  // ########################  Ficheiros  ######################### //
  // ############################################################## //

  const [ficheiros, setFicheiros] = useState([]);
  const [datePickerValues, setDatePickerValues] = useState({});

  const handleFilesChange = (e, index, ficheiro) => {
    const file = e.target.files[0];

    setFicheiros((prevFicheiros) => {
      const updatedFicheiros = [...prevFicheiros];
      updatedFicheiros[index] = {
        file,
        idTipo: ficheiro.id_crede_elementos_files_tipos,
        path: ficheiro.crede_elementos_files_tipos_path,
      };

      // Preenche os índices vazios com objetos vazios
      for (let i = 0; i < updatedFicheiros.length; i++) {
        if (updatedFicheiros[i] === undefined) {
          updatedFicheiros[i] = null; // ou { file: null, idTipo: null, path: null } para manter a estrutura
        }
      }

      return updatedFicheiros;
    });
  };

  const handleRemoveFiles = (index) => {
    setFicheiros((prevFicheiros) => {
      const updatedFicheiros = [...prevFicheiros];
      updatedFicheiros[index] = null;

      // Preenche os índices vazios com objetos vazios
      for (let i = 0; i < updatedFicheiros.length; i++) {
        if (updatedFicheiros[i] === undefined) {
          updatedFicheiros[i] = null; // ou { file: null, idTipo: null, path: null } para manter a estrutura
        }
      }

      return updatedFicheiros;
    });
  };

  const handleDatePickerChange = (date, index) => {
    setDatePickerValues((prevValues) => {
      return {
        ...prevValues,
        [index]: date,
      };
    });
  };

  // ############################################################## //
  // ######################  Modal Rascunho  ###################### //
  // ############################################################## //

  const [openRascunho, setOpenRascunho] = useState(false);
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);
  const [modalState, setModalState] = useState("");

  const handleOpen = (e, ydata) => {
    e.preventDefault();

    setLoading(false);
    setDados(ydata);
    setModalState("edit");
    setOpenRascunho(true);
  };

  const handleClose = (e) => {
    e.preventDefault();
    setOpenRascunho(false);
  };

  // ############################################################## //
  // ##################  Tipo de Credenciações  ################### //
  // ############################################################## //

  const [tipoCredSel, setTipoCredSel] = useState({ id: null, descricao: "" });

  const tiposCreds = [
    {
      id: 1,
      descricao: "Permanente",
      permissao: "APP_CRED_CREDENCIACOES_PERM_FUNCIONARIO",
    },
  ];

  // ############################################################## //
  // ###################  Verificar Formulário  ################### //
  // ############################################################## //

  // Verify form credenciação pontual
  const verifyFormPontual = () => {
    // Check if the required fields are filled
    if (carAccess) {
      const isRequiredFilled =
        !!veiculo.id && !!estado.id && !!tipoCredenciacao.id;
      return isRequiredFilled;
    } else {
      const isRequiredFilled =
        !!funcionario.id &&
        !!estado.id &&
        !!aeroporto.id &&
        !!motivo.id &&
        !!tipoCredenciacao.id;
      return isRequiredFilled;
    }
  };

  // ############################################################## //
  // #################  Credenciação Selecionada  ################# //
  // ############################################################## //

  const credenciacaoSelecionada = useSelector(
    (state) =>
      state &&
      state.credenciais &&
      state.credenciais.credenciacao &&
      state.credenciais.credenciacao.credenciacao
  );

  useEffect(() => {
    if (credenciacaoSelecionada) {
      setCredenciacao({
        inscricao_adicional:
          credenciacaoSelecionada.crede_elementos_credenciacao_inscricao_adicional,
        obs: credenciacaoSelecionada.crede_elementos_credenciacao_obs,
        pedido_nr:
          credenciacaoSelecionada.crede_elementos_credenciacao_pedido_nr,
        matricula: credenciacaoSelecionada.crede_credenciacao_veiculo_matricula,
        nr_cartao: credenciacaoSelecionada.crede_elementos_credenciacao_numero,
        motivo_recusa:
          credenciacaoSelecionada.crede_elementos_credenciacao_refused_obs,
        desc_trab: credenciacaoSelecionada.crede_elementos_credenciacao_desc,
      });

      setVeiculo({
        id: credenciacaoSelecionada.id_crede_credenciacao_veiculo,
        descricao: credenciacaoSelecionada.crede_credenciacao_veiculo_matricula,
      });

      setAreaA(
        credenciacaoSelecionada.crede_elementos_credenciacao_area_acesso_a ==
          "0"
          ? false
          : true
      );
      setAreaB(
        credenciacaoSelecionada.crede_elementos_credenciacao_area_acesso_b ==
          "0"
          ? false
          : true
      );
      setAreaC(
        credenciacaoSelecionada.crede_elementos_credenciacao_area_acesso_c ==
          "0"
          ? false
          : true
      );
      setAreaE(
        credenciacaoSelecionada.crede_elementos_credenciacao_area_acesso_e ==
          "0"
          ? false
          : true
      );
      setAreaI(
        credenciacaoSelecionada.crede_elementos_credenciacao_area_acesso_i ==
          "0"
          ? false
          : true
      );
      setAreaL(
        credenciacaoSelecionada.crede_elementos_credenciacao_area_acesso_l ==
          "0"
          ? false
          : true
      );
      setAreaM(
        credenciacaoSelecionada.crede_elementos_credenciacao_area_acesso_m ==
          "0"
          ? false
          : true
      );
      setAreaO(
        credenciacaoSelecionada.crede_elementos_credenciacao_area_acesso_o ==
          "0"
          ? false
          : true
      );
      setAreaP(
        credenciacaoSelecionada.crede_elementos_credenciacao_area_acesso_p ==
          "0"
          ? false
          : true
      );
      setAreaT(
        credenciacaoSelecionada.crede_elementos_credenciacao_area_acesso_t ==
          "0"
          ? false
          : true
      );
      setCheckIn(
        credenciacaoSelecionada.crede_elementos_credenciacao_porta_check_in ==
          "0"
          ? false
          : true
      );
      setPortaEm(
        credenciacaoSelecionada.crede_elementos_credenciacao_porta_embarque ==
          "0"
          ? false
          : true
      );
      setPortaDes(
        credenciacaoSelecionada.crede_elementos_credenciacao_porta_desembarque ==
          "0"
          ? false
          : true
      );
      setOutrasPortas(
        credenciacaoSelecionada.crede_elementos_credenciacao_porta_outras == "0"
          ? false
          : true
      );
      setRenovacao(
        credenciacaoSelecionada.crede_elementos_credenciacao_renovar_cartao ==
          "0"
          ? false
          : true
      );
      setAlteracao(
        credenciacaoSelecionada.crede_elementos_credenciacao_pedido_alteracao_areas ==
          "0"
          ? false
          : true
      );
      setPedido(
        credenciacaoSelecionada.crede_elementos_credenciacao_pedido_segunda_via ==
          "0"
          ? false
          : true
      );
      setInquerito(
        credenciacaoSelecionada.crede_elementos_credenciacao_area_acesso_a ==
          "0"
          ? false
          : true
      );
      setTools(
        credenciacaoSelecionada.crede_elementos_credenciacao_with_tools == "0"
          ? false
          : true
      );
      setCarAccess(
        credenciacaoSelecionada.crede_elementos_credenciacao_car_access == "0"
          ? false
          : true
      );
      setVinculoInicial(
        credenciacaoSelecionada.crede_elementos_credenciacao_vinculo_laboral_inicio
      );
      setVinculoFinal(
        credenciacaoSelecionada.crede_elementos_credenciacao_vinculo_laboral_fim
      );
      setAcessoInicial(
        credenciacaoSelecionada.crede_elementos_credenciacao_validade_inicio
      );
      setAcessoFinal(
        credenciacaoSelecionada.crede_elementos_credenciacao_validade_fim
      );
      setHorasInicial(
        credenciacaoSelecionada.crede_elementos_credenciacao_horario_inicio
      );
      setHorasFinal(
        credenciacaoSelecionada.crede_elementos_credenciacao_horario_fim
      );

      setFuncionario({
        id: credenciacaoSelecionada.id_crede_elementos,
        nome: credenciacaoSelecionada.nome_funcionario
          ? credenciacaoSelecionada.nome_funcionario
          : "--",
      });
      setAeroporto({
        id: credenciacaoSelecionada.id_crede_aeroportos,
        descricao: credenciacaoSelecionada.nome_aeroporto
          ? credenciacaoSelecionada.nome_aeroporto
          : "--",
      });
      setEstado({
        id: credenciacaoSelecionada.id_crede_credenciacao_estado,
        descricao: credenciacaoSelecionada.nome_estado
          ? credenciacaoSelecionada.nome_estado
          : "--",
      });
      setFuncao({
        id: credenciacaoSelecionada.id_crede_credenciacao_funcao,
        descricao: credenciacaoSelecionada.nome_funcao
          ? credenciacaoSelecionada.nome_funcao
          : "--",
      });
      setTipoCartao({
        id: credenciacaoSelecionada.id_crede_credenciacao_tipo_cartao,
        descricao: credenciacaoSelecionada.tipo_cartao
          ? credenciacaoSelecionada.tipo_cartao
          : "--",
      });
      setTipoVinculo({
        id: credenciacaoSelecionada.id_crede_credenciacao_tipo_vinculo,
        descricao: credenciacaoSelecionada.tipo_vinculo
          ? credenciacaoSelecionada.tipo_vinculo
          : "--",
      });
      setCor({
        id: credenciacaoSelecionada.id_crede_credenciacao_cor,
        descricao: credenciacaoSelecionada.nome_cor
          ? credenciacaoSelecionada.nome_cor
          : "--",
      });
      setAcompanhante({
        id: credenciacaoSelecionada.id_crede_elementos_credenciacao_acompanhante,
        nome: credenciacaoSelecionada.nome_acompanhante
          ? credenciacaoSelecionada.nome_acompanhante
          : "--",
        numero: credenciacaoSelecionada.numero_acompanhante,
      });
      setMotivo({
        id: credenciacaoSelecionada.id_crede_credenciacao_motivo,
        descricao: credenciacaoSelecionada.motivo
          ? credenciacaoSelecionada.motivo
          : "--",
      });
      setTipoVeiculo({
        id: credenciacaoSelecionada.id_crede_credenciacao_tipo_veiculo,
        descricao: credenciacaoSelecionada.veiculo
          ? credenciacaoSelecionada.veiculo
          : "--",
      });
      setPortAcesso({
        id: credenciacaoSelecionada.id_crede_credenciacao_portaria_acesso,
        descricao: credenciacaoSelecionada.portariaAcesso
          ? credenciacaoSelecionada.portariaAcesso
          : "--",
      });
      setTipoCombustivel({
        id: credenciacaoSelecionada.id_crede_credenciacao_tipo_combustivel,
        descricao: credenciacaoSelecionada.combustivel
          ? credenciacaoSelecionada.combustivel
          : "--",
      });
      setProjeto({
        id: credenciacaoSelecionada.id_obra,
        descricao: credenciacaoSelecionada.obra
          ? credenciacaoSelecionada.obra
          : "--",
      });
      setVeiculo({
        id: credenciacaoSelecionada.id_crede_credenciacao_veiculo,
        descricao: credenciacaoSelecionada.crede_credenciacao_veiculo_matricula
          ? credenciacaoSelecionada.crede_credenciacao_veiculo_matricula
          : "--",
      });
      if (credenciacaoSelecionada.destinatarios) {
        setDestinatarios(JSON.parse(credenciacaoSelecionada.destinatarios));
      }
      const datesArray = credenciacaoSelecionada.datas_array
        ? credenciacaoSelecionada.datas_array
            .split(",")
            .map((date) => new Date(date))
        : null;
      setDatasSelected(datesArray);
    }
  }, [credenciacaoSelecionada, setCredenciacao]);

  console.log(datasSelected);

  // ############################################################## //
  // #################  Funcionário Selecionado  ################## //
  // ############################################################## //

  const funcionarioSelecionado = useSelector(
    (state) =>
      state.credenciais.credenciacao &&
      state.credenciais.credenciacao.funcionario
  );

  useEffect(() => {
    if (funcionarioSelecionado) {
      setFuncionarioSel({
        categoria_profissional:
          funcionarioSelecionado.crede_elementos_categoria_profissional,
        cp: funcionarioSelecionado.crede_elementos_cp,
        data_nascimento: funcionarioSelecionado.crede_elementos_data_nascimento,
        doc_data_emissao:
          funcionarioSelecionado.crede_elementos_doc_data_emissao,
        doc_entidade_emissora:
          funcionarioSelecionado.crede_elementos_doc_entidade_emissora,
        doc_nr_identificacao:
          funcionarioSelecionado.crede_elementos_doc_nr_identificacao,
        doc_nr_identificacao_controlo:
          funcionarioSelecionado.crede_elementos_doc_nr_identificacao_controlo,
        doc_validade: funcionarioSelecionado.crede_elementos_doc_validade,
        doc_vitalicio: funcionarioSelecionado.crede_elementos_doc_vitalicio,
        email: funcionarioSelecionado.crede_elementos_email,
        filiacao_mae: funcionarioSelecionado.crede_elementos_filiacao_mae,
        filiacao_pai: funcionarioSelecionado.crede_elementos_filiacao_pai,
        funcao: funcionarioSelecionado.crede_elementos_funcao,
        local_nascimento:
          funcionarioSelecionado.crede_elementos_local_nascimento,
        localidade: funcionarioSelecionado.crede_elementos_localidade,
        morada: funcionarioSelecionado.crede_elementos_morada,
        nacionalidade: funcionarioSelecionado.crede_elementos_nacionalidade,
        nif: funcionarioSelecionado.crede_elementos_nif,
        nome: funcionarioSelecionado.crede_elementos_nome,
        telefone: funcionarioSelecionado.crede_elementos_telefone,
        telemovel: funcionarioSelecionado.crede_elementos_telemovel,
      });
      setDataEmissao(funcionarioSelecionado.crede_elementos_doc_data_emissao);
      setDataNascimento(funcionarioSelecionado.crede_elementos_data_nascimento);
      setDataValidade(funcionarioSelecionado.crede_elementos_doc_validade);
      setVitalicio(
        funcionarioSelecionado.crede_elementos_doc_vitalicio == "0"
          ? false
          : true
      );
      setHabilitacao({
        id: funcionarioSelecionado.id_crede_elementos_habilitacoes_tipos,
        descricao: funcionarioSelecionado.nome_habilitacoes,
      });
      setTipoDoc({
        id: funcionarioSelecionado.id_crede_tipo_doc_identificacao,
        descricao: funcionarioSelecionado.nome_tipo_doc_identificacao,
      });
      setEmpresa({
        id: funcionarioSelecionado.id_crede_fornecedores_servicos,
        descricao: funcionarioSelecionado.nome_fornecedores_servicos,
      });
    }
  }, [funcionarioSelecionado]);

  // ############################################################## //
  // #################  Acompanhante Selecionado  ################# //
  // ############################################################## //

  const acompanhanteSelecionado = useSelector(
    (state) => state.credenciais.acompanhante
  );

  // ############################################################## //
  // ######################  Switch Estados  ###################### //
  // ############################################################## //

  let estadosFiltered;

  switch (
    credenciacaoSelecionada &&
    credenciacaoSelecionada.id_crede_credenciacao_estado
  ) {
    case 1:
      estadosFiltered = estados.filter((e) => e.id === 1 || e.id === 2);
      break;
    case 4:
      estadosFiltered = estados.filter((e) => e.id === 4 || e.id === 6);
      break;
    case 5:
      estadosFiltered = estados.filter((e) => e.id === 1 || e.id === 2);
      break;
    default:
      estadosFiltered = [];
      break;
  }

  // ############################################################## //
  // ##############  Handle Change and Submit Form  ############### //
  // ############################################################## //

  const handleChange = (e) => {
    e.preventDefault();
    setCredenciacao({
      ...credenciacao,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const ds =
      datasSelected &&
      datasSelected.map((date) => {
        return moment(date).format("YYYY-MM-DD");
      });
    const ydata = [
      {
        funcionario_id: funcionario.id,
        estado_id: estado.id,
        pedido_nr: credenciacao.pedido_nr,
        motivo_recusa: credenciacao.motivo_recusa,
        area_acesso_a: areaA,
        area_acesso_b: areaB,
        area_acesso_c: areaC,
        area_acesso_e: areaE,
        area_acesso_i: areaI,
        area_acesso_l: areaL,
        area_acesso_m: areaM,
        area_acesso_o: areaO,
        area_acesso_p: areaP,
        area_acesso_t: areaT,
        inscricao_adicional: credenciacao.inscricao_adicional,
        obs: credenciacao.obs,
        validade_inicio: acessoInicial
          ? moment(acessoInicial).format("YYYY-MM-DD")
          : null,
        validade_fim: acessoFinal
          ? moment(acessoFinal).format("YYYY-MM-DD")
          : null,
        horario_inicio: dayjs(horasInicial).format("YYYY-MM-DD HH:mm:ss"),
        horario_fim: dayjs(horasFinal).format("YYYY-MM-DD HH:mm:ss"),
        renovar_cartao: renovacao,
        pedido_segunda_via: pedido,
        pedido_alteracao_areas: alteracao,
        vinculo_laboral_inicio: vinculoInicial
          ? moment(vinculoInicial).format("YYYY-MM-DD")
          : null,
        vinculo_laboral_fim: vinculoFinal
          ? moment(vinculoFinal).format("YYYY-MM-DD")
          : null,
        inquerito_pessoal_exito: inquerito,
        porta_check_in: checkIn,
        porta_embarque: portaEm,
        porta_desembarque: portaDes,
        porta_outras: outrasPortas,
        aeroporto_id: aeroporto.id,
        tipoCartao: tipoCartao.id,
        funcao_id: funcao.id,
        cor_id: cor.id,
        tipoVinculo: tipoVinculo.id,
        tipoCredenciacao:
          tipoCredSel.id == null ? tipoCredenciacao.id : tipoCredSel.id,
        acompanhante_id: acompanhante.id,
        acompanhante_nome: acompanhante.nome,
        acompanhante_cartao: acompanhante.numero,
        motivo_id: motivo.id,
        numero_cred: credenciacao.numero_cred,
        tools: tools,
        car_access: carAccess,
        veiculo_id: veiculo.id,
        portAcesso_id: portAcesso.id,
        rascunho: 0,
        selectedDates: ds,
        projeto_id: projeto.id,
        projeto_nome: projeto.descricao,
        desc_trab: credenciacao.desc_trab,
        destinatarios: destinatarios,
      },
    ];

    console.log(ydata);

    const errorMessage = {
      isOpen: true,
      message: "Ocorreu um erro!",
      type: "error",
    };
    const message = {
      isOpen: true,
      message: "Credenciação editada com sucesso!!",
      type: "success",
    };
    const messageEmail = {
      isOpen: true,
      message: "Email enviado com sucesso!!",
      type: "success",
    };
    const messageEmailErro = {
      isOpen: true,
      message: "Email não foi enviado tente novamente!",
      type: "warning",
    };

    if (verifyFormPontual()) {
      dispatch(
        EditCredenciacao(
          ydata,
          credenciacaoSelecionada.id_crede_elementos_credenciacao,
          copiaCredenciacao,
          copiaCredenciacaoExterna,
          ficheiros,
          datePickerValues,
          toggleDrawer,
          ShowNotification,
          message,
          errorMessage
        )
      ).then(() => {
        toggleDrawer("right", false);
        fetchCredenciacoes();
        globalFetch(estado.id);
        // dispatch(
        //   SendCredNotifications(
        //     credenciacaoSelecionada.id_crede_elementos_credenciacao,
        //     estado.id
        //   )
        // );
        dispatch(
          NotifyCredenciacoes(
            credenciacaoSelecionada.id_crede_elementos_credenciacao,
            estado.id
          )
        );
        dispatch(ShowNotification(message));
      });
      // .then(() => {
      //   if (estado.id == 3) {
      //     if (
      //       credenciacaoSelecionada.id_crede_credenciacao_tipo == 2 ||
      //       credenciacaoSelecionada.id_crede_credenciacao_tipo == 3
      //     ) {
      //       dispatch(
      //         SendCredPontual(
      //           credenciacaoSelecionada.id_crede_elementos_credenciacao,
      //           ShowNotification,
      //           messageEmail,
      //           messageEmailErro
      //         )
      //       );
      //     }
      //     if (credenciacaoSelecionada.id_crede_credenciacao_tipo == 5) {
      //       dispatch(
      //         SendCredPontualViatura(
      //           credenciacaoSelecionada.id_crede_elementos_credenciacao,
      //           ShowNotification,
      //           messageEmail,
      //           messageEmailErro
      //         )
      //       );
      //     }
      //   }
      // });
    } else {
      // dispatch(ShowNotification(warningMessage));
      ydata[0] = { ...ydata[0], rascunho: 1 };
      handleOpen(e, ydata);
    }
  };

  const fetchCredFuncionarios = () => {
    dispatch(GetCredFuncionarios());
  };

  const fetchCredCopiaCredenciacaoUploaded = (credId) => {
    dispatch(GetCredCopiaCredenciacaoUploaded(credId));
  };

  useEffect(() => {
    fetchCredFuncionarios();
    fetchCredCopiaCredenciacaoUploaded(credenciacaoId);
  }, []);

  return (
    <div
      className={classes.list}
      style={
        dimensions.width <= 1100
          ? { width: "60vw" }
          : { width: `${drawerWidth}` }
      }
    >
      <ModalRascunho
        openRascunho={openRascunho}
        handleClose={handleClose}
        fetchCredenciacoes={fetchCredenciacoes}
        handleSubmit={handleSubmit}
        dados={dados}
        loading={loading}
        setLoading={setLoading}
        ficheiros={ficheiros}
        datePickerValues={datePickerValues}
        toggleDrawer={toggleDrawer}
        ShowNotification={ShowNotification}
        modalState={modalState}
        idElem={
          credenciacaoSelecionada &&
          credenciacaoSelecionada.id_crede_elementos_credenciacao
        }
        copiaCredenciacao={copiaCredenciacao}
      />
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          m: 5,
        }}
      >
        <Box
          sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
          onClick={() => toggleDrawer("right", false)}
        >
          <div>
            <FeatherIcon
              icon="chevron-left"
              size={20}
              style={{ strokeWidth: "1.5" }}
            />
          </div>
          <div className="text-underline-close-drawer">Credenciações</div>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Button
            variant="contained"
            className={classes.btnFiltrar}
            onClick={handleSubmit}
          >
            Guardar
          </Button>
        </Box>
      </Box>
      <Card
        sx={{
          m: 5,
          p: 2,
          boxShadow: "0px 10px 15px lightgrey",
        }}
      >
        <Box
          sx={{
            m: 2,
          }}
        >
          <h4
            style={{
              fontSize: "22px",
              width: "100%",
              marginBottom: "0px",
            }}
            className="text-underline"
          >
            Credenciação{" "}
            {credenciacaoSelecionada &&
              credenciacaoSelecionada.crede_credenciacao_tipo_nome}
          </h4>
        </Box>
        <Box sx={{ m: 2, width: "30%" }}>
          <Typography style={{ fontWeight: "bold", marginBottom: "10px" }}>
            Mudar tipo de credenciação
          </Typography>
          <Autocomplete
            // disabled={!superuser && estado.id != 1 ? true : false}
            fullWidth
            name="tipoCred"
            clearText="Limpar"
            openText="Abrir"
            closeText="Fechar"
            noOptionsText="Sem dados"
            value={tipoCredSel}
            className="unidadesId-form"
            options={tiposCreds || []}
            getOptionLabel={(option) => `${option.descricao}` || ""}
            isOptionEqualToValue={(option, value) => {
              // if (!value.id) return true;
              return value.id === option.id;
            }}
            style={{ width: "100%" }}
            renderInput={(params) => (
              <TextField {...params} size="small" variant="outlined" />
            )}
            onChange={(_, value, reason) => {
              if (reason === "clear") {
                setTipoCredSel({ id: null, descricao: "" });
                return;
              } else {
                if (value.id == 5) {
                  setCarAccess(true);
                } else {
                  setCarAccess(false);
                }
                setTipoCredSel(value);
                return value;
              }
            }}
          />
        </Box>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          {credenciacaoSelecionada &&
            credenciacaoSelecionada.id_crede_credenciacao_tipo != 5 && (
              <Box sx={{ m: 2, width: "23%" }}>
                <Typography
                  style={{ fontWeight: "bold", marginBottom: "10px" }}
                >
                  Nome *
                </Typography>
                <Autocomplete
                  disabled
                  fullWidth
                  name="nome"
                  clearText="Limpar"
                  openText="Abrir"
                  closeText="Fechar"
                  noOptionsText="Sem dados"
                  value={funcionario}
                  className="unidadesId-form"
                  options={funcionarios || []}
                  getOptionLabel={(option) => `${option.nome}` || ""}
                  isOptionEqualToValue={(option, value) => {
                    // if (!value.id) return true;
                    return value.id === option.id;
                  }}
                  style={{ width: "100%" }}
                  renderInput={(params) => (
                    <TextField {...params} size="small" variant="outlined" />
                  )}
                  onChange={(_, value) => {
                    setFuncionario(value);
                    return value;
                  }}
                />
              </Box>
            )}
          <Box
            sx={{
              m: 2,
              width:
                credenciacaoSelecionada &&
                credenciacaoSelecionada.id_crede_credenciacao_tipo != 5
                  ? "20%"
                  : "30%",
            }}
          >
            <Typography style={{ fontWeight: "bold", marginBottom: "10px" }}>
              Estado *
            </Typography>
            <Autocomplete
              disabled={
                !superuser &&
                credenciacaoSelecionada &&
                credenciacaoSelecionada.id_crede_credenciacao_estado != 1 &&
                credenciacaoSelecionada.id_crede_credenciacao_estado != 4 &&
                credenciacaoSelecionada.id_crede_credenciacao_estado != 5
                  ? true
                  : false
              }
              fullWidth
              name="nome"
              clearText="Limpar"
              openText="Abrir"
              closeText="Fechar"
              noOptionsText="Sem dados"
              value={estado}
              className="unidadesId-form"
              options={!superuser ? estadosFiltered : estados}
              getOptionLabel={(option) => `${option.descricao}` || ""}
              isOptionEqualToValue={(option, value) => {
                // if (!value.id) return true;
                return value.id === option.id;
              }}
              style={{ width: "100%" }}
              renderInput={(params) => (
                <TextField {...params} size="small" variant="outlined" />
              )}
              onChange={(_, value, reason) => {
                if (reason === "clear") {
                  setEstado({ id: null, descricao: "" });
                  return;
                } else {
                  setEstado(value);
                  return value;
                }
              }}
            />
          </Box>
          <Box
            sx={{
              m: 2,
              width:
                credenciacaoSelecionada &&
                credenciacaoSelecionada.id_crede_credenciacao_tipo != 5
                  ? "20%"
                  : "30%",
            }}
          >
            <Typography style={{ fontWeight: "bold", marginBottom: "10px" }}>
              Obra
            </Typography>
            <Autocomplete
              disabled={
                credenciacaoSelecionada &&
                credenciacaoSelecionada.id_obra != null
                  ? true
                  : false
              }
              fullWidth
              name="nome"
              clearText="Limpar"
              openText="Abrir"
              closeText="Fechar"
              noOptionsText="Sem dados"
              value={projeto}
              className="unidadesId-form"
              options={obrasState || []}
              getOptionLabel={(option) => `${option.descricao}` || ""}
              isOptionEqualToValue={(option, value) => {
                // if (!value.id) return true;
                return value.id === option.id;
              }}
              style={{ width: "100%" }}
              renderInput={(params) => (
                <TextField {...params} size="small" variant="outlined" />
              )}
              onChange={(_, value, reason) => {
                if (reason === "clear") {
                  setProjeto({ id: null, descricao: "" });
                  return;
                } else {
                  setProjeto(value);
                  return value;
                }
              }}
            />
          </Box>
          <Box
            sx={{
              m: 2,
              width:
                credenciacaoSelecionada &&
                credenciacaoSelecionada.id_crede_credenciacao_tipo != 5
                  ? "30%"
                  : "30%",
            }}
          >
            <Typography style={{ fontWeight: "bold", marginBottom: "10px" }}>
              Descrição dos trabalhos
            </Typography>
            <TextField
              name="desc_trab"
              size="small"
              variant="outlined"
              value={credenciacao.desc_trab}
              onChange={handleChange}
              style={{ width: "100%" }}
              autoComplete="off"
            />
          </Box>
        </Box>
        {estado.descricao == "Levantada" ? (
          <Box
            sx={{
              mb: 2,
              mx: 2,
            }}
          >
            <Box sx={{ width: "100%" }}>
              <h4
                style={{ color: "#E21450" }}
                className="text-underline-title-drawer "
              >
                Credenciação
              </h4>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              {uploadedCopia && (
                <Button
                  sx={{
                    height: "40px",
                    borderRadius: "5px",
                    mr: 1,
                  }}
                  className={classes.btnUpload}
                  onClick={() => {
                    Instance()
                      .get(
                        `${BASE_URL}/credenciacoes/funcionarios/files/${uploadedCopia.id_crede_elementos_files}/download`,
                        { responseType: "blob" }
                      )
                      .then(({ data }) => {
                        const filename =
                          uploadedCopia.crede_elementos_files_path.replace(
                            /^.*[\\/]/,
                            ""
                          );
                        fileDownload(data, filename);
                      })
                      .catch((err) => {
                        console.log(err.response);
                        if (err.response) {
                          if (err.response === 403) {
                            // dispatch(ShowNotification(errorMessage));
                          }
                        }
                      });
                  }}
                >
                  <FeatherIcon icon="download" size={20} />
                </Button>
              )}
              <Button
                sx={{
                  height: "40px",
                  width: "200px",
                  borderRadius: "5px",
                  mr: 2,
                }}
                onChange={(e) => handleCopiaChange(e, copCred)}
                className={classes.btnUpload}
              >
                <label
                  htmlFor={copCred.crede_elementos_files_tipos_nome_input}
                  className="custom-file-upload"
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "start",
                      cursor: "pointer",
                    }}
                  >
                    <p> Carregar Ficheiro</p>
                  </div>
                </label>
                <input
                  type="file"
                  name={copCred.crede_elementos_files_tipos_nome_input}
                  id={copCred.crede_elementos_files_tipos_nome_input}
                  hidden
                  accept=".pdf"
                />
              </Button>
              <div style={{ width: "auto" }}>
                {copiaCredenciacao &&
                  copiaCredenciacao.map((copiaCredenciacao, index) => {
                    return (
                      <div
                        style={{
                          // marginRight: "10px",
                          display: "flex",
                          alignItems: "center",
                        }}
                        key={index}
                      >
                        {/* {copiaCredenciacao.file.name} */}
                        <IconButton
                          onClick={() => {
                            const fileName = copiaCredenciacao.file.name;
                            const fileExtension = fileName.slice(
                              (Math.max(0, fileName.lastIndexOf(".")) ||
                                Infinity) + 1
                            );

                            if (fileExtension == "pdf") {
                              const pdfFile = copiaCredenciacao.file;

                              // Create a Blob from the PDF file
                              const blob = new Blob([pdfFile], {
                                type: "application/pdf",
                              });

                              // Create a URL for the Blob
                              const blobUrl = URL.createObjectURL(blob);

                              // Now you can use `blobUrl` to open or display the PDF
                              window.open(blobUrl, "_blank");
                            } else {
                              const blobUrl = URL.createObjectURL(
                                copiaCredenciacao.file
                              );

                              // Now you can use `blobUrl` to open or display the PDF
                              window.open(blobUrl, "_blank");
                            }
                          }}
                        >
                          <FeatherIcon icon="eye" size={"1rem"} />
                        </IconButton>
                        <IconButton
                          onClick={(e) =>
                            handleRemoveCopia(e, copiaCredenciacao)
                          }
                        >
                          <FeatherIcon icon="trash-2" size={"1rem"} />
                        </IconButton>
                      </div>
                    );
                  })}
              </div>
            </Box>
          </Box>
        ) : estado.descricao == "Recusada" ? (
          <Box
            sx={{
              mx: 2,
              display: "flex",
              width: "46.5%",
              flexDirection: "column",
            }}
          >
            <Typography style={{ fontWeight: "bold", marginBottom: "10px" }}>
              Motivo de Recusa
            </Typography>
            <TextField
              name="motivo_recusa"
              disabled={!superuser && estado.id != 1 ? true : false}
              multiline
              rows={2}
              size="small"
              variant="outlined"
              value={credenciacao.motivo_recusa}
              onChange={handleChange}
              style={{ width: "100%" }}
              autoComplete="off"
            />
          </Box>
        ) : null}
        {credenciacaoSelecionada &&
          credenciacaoSelecionada.id_crede_credenciacao_tipo != 5 && (
            <>
              <Box
                sx={{
                  mb: 2,
                  mx: 2,
                  display: "flex",
                  alignItems: "flex-end",
                }}
              >
                <Box sx={{ width: "100%" }}>
                  <h4
                    style={{ color: "#E21450" }}
                    className="text-underline-title-drawer "
                  >
                    Funcionário Info
                  </h4>
                </Box>
                <Box>
                  <h4
                    onClick={() => setOpen(!open)}
                    className="text-underline-title-drawer"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    {open ? (
                      <FeatherIcon
                        icon="chevron-up"
                        strokeWidth={2}
                        color="#707070"
                        sx={{ pt: 1 }}
                      />
                    ) : (
                      <FeatherIcon
                        icon="chevron-down"
                        strokeWidth={2}
                        color="#707070"
                        sx={{ pt: 1 }}
                      />
                    )}
                  </h4>
                </Box>
              </Box>
              <Collapse in={open}>
                <Card
                  sx={{
                    m: 2,
                    boxShadow: "0px 10px 15px lightgrey",
                  }}
                >
                  <Box sx={{ m: 2 }}>
                    <h4
                      style={{ color: "#E21450" }}
                      className="text-underline-title-drawer "
                    >
                      Detalhes Pessoais
                    </h4>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      mx: 1,
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        width: "48%",
                      }}
                    >
                      <Box sx={{ m: 1 }}>
                        <Typography
                          style={{ fontWeight: "bold", marginBottom: "10px" }}
                        >
                          Nome Completo
                        </Typography>
                        <TextField
                          disabled
                          name="nome"
                          size="small"
                          variant="outlined"
                          value={funcionarioSel.nome}
                          onChange={handleChange}
                          style={{ width: "100%" }}
                        />
                      </Box>
                      <Box sx={{ m: 1 }}>
                        <Typography
                          style={{ fontWeight: "bold", marginBottom: "10px" }}
                        >
                          Morada
                        </Typography>
                        <TextField
                          disabled
                          multiline
                          rows={2}
                          name="morada"
                          size="small"
                          variant="outlined"
                          value={funcionarioSel.morada}
                          onChange={handleChange}
                          style={{ width: "100%" }}
                          className={
                            funcionarioSelecionado &&
                            funcionarioSelecionado.crede_elementos_ocultar_flag ==
                              1
                              ? classes.textField
                              : null
                          }
                          InputProps={{
                            readOnly: true, // Make the TextField read-only
                            classes: {
                              root:
                                funcionarioSelecionado &&
                                funcionarioSelecionado.crede_elementos_ocultar_flag ==
                                  1
                                  ? classes.disabledTextField
                                  : null, // Apply the disabledTextField class to the root element
                              input:
                                funcionarioSelecionado &&
                                funcionarioSelecionado.crede_elementos_ocultar_flag ==
                                  1
                                  ? classes.blurredText
                                  : null, // Apply the blurred text class to the input element
                            },
                          }}
                        />
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Box sx={{ m: 1, width: "46.5%" }}>
                          <Typography
                            style={{ fontWeight: "bold", marginBottom: "10px" }}
                          >
                            Localidade
                          </Typography>
                          <TextField
                            disabled
                            name="localidade"
                            size="small"
                            variant="outlined"
                            value={funcionarioSel.localidade}
                            onChange={handleChange}
                            style={{ width: "100%" }}
                            className={
                              funcionarioSelecionado &&
                              funcionarioSelecionado.crede_elementos_ocultar_flag ==
                                1
                                ? classes.textField
                                : null
                            }
                            InputProps={{
                              readOnly: true, // Make the TextField read-only
                              classes: {
                                root:
                                  funcionarioSelecionado &&
                                  funcionarioSelecionado.crede_elementos_ocultar_flag ==
                                    1
                                    ? classes.disabledTextField
                                    : null, // Apply the disabledTextField class to the root element
                                input:
                                  funcionarioSelecionado &&
                                  funcionarioSelecionado.crede_elementos_ocultar_flag ==
                                    1
                                    ? classes.blurredText
                                    : null, // Apply the blurred text class to the input element
                              },
                            }}
                          />
                        </Box>
                        <Box sx={{ m: 1, width: "46.5%" }}>
                          <Typography
                            style={{ fontWeight: "bold", marginBottom: "10px" }}
                          >
                            Código Postal
                          </Typography>
                          <TextField
                            disabled
                            name="cp"
                            size="small"
                            variant="outlined"
                            value={funcionarioSel.cp}
                            onChange={handleChange}
                            style={{ width: "100%" }}
                            className={
                              funcionarioSelecionado &&
                              funcionarioSelecionado.crede_elementos_ocultar_flag ==
                                1
                                ? classes.textField
                                : null
                            }
                            InputProps={{
                              readOnly: true, // Make the TextField read-only
                              classes: {
                                root:
                                  funcionarioSelecionado &&
                                  funcionarioSelecionado.crede_elementos_ocultar_flag ==
                                    1
                                    ? classes.disabledTextField
                                    : null, // Apply the disabledTextField class to the root element
                                input:
                                  funcionarioSelecionado &&
                                  funcionarioSelecionado.crede_elementos_ocultar_flag ==
                                    1
                                    ? classes.blurredText
                                    : null, // Apply the blurred text class to the input element
                              },
                            }}
                          />
                        </Box>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Box sx={{ m: 1, width: "46.5%" }}>
                          <Typography
                            style={{ fontWeight: "bold", marginBottom: "10px" }}
                          >
                            Telefone
                          </Typography>
                          <TextField
                            disabled
                            name="telefone"
                            size="small"
                            variant="outlined"
                            value={funcionarioSel.telefone}
                            onChange={handleChange}
                            style={{ width: "100%" }}
                            className={
                              funcionarioSelecionado &&
                              funcionarioSelecionado.crede_elementos_ocultar_flag ==
                                1
                                ? classes.textField
                                : null
                            }
                            InputProps={{
                              readOnly: true, // Make the TextField read-only
                              classes: {
                                root:
                                  funcionarioSelecionado &&
                                  funcionarioSelecionado.crede_elementos_ocultar_flag ==
                                    1
                                    ? classes.disabledTextField
                                    : null, // Apply the disabledTextField class to the root element
                                input:
                                  funcionarioSelecionado &&
                                  funcionarioSelecionado.crede_elementos_ocultar_flag ==
                                    1
                                    ? classes.blurredText
                                    : null, // Apply the blurred text class to the input element
                              },
                            }}
                          />
                        </Box>
                        <Box sx={{ m: 1, width: "46.5%" }}>
                          <Typography
                            style={{ fontWeight: "bold", marginBottom: "10px" }}
                          >
                            Telemóvel
                          </Typography>
                          <TextField
                            disabled
                            name="telemovel"
                            size="small"
                            variant="outlined"
                            value={funcionarioSel.telemovel}
                            onChange={handleChange}
                            style={{ width: "100%" }}
                            className={
                              funcionarioSelecionado &&
                              funcionarioSelecionado.crede_elementos_ocultar_flag ==
                                1
                                ? classes.textField
                                : null
                            }
                            InputProps={{
                              readOnly: true, // Make the TextField read-only
                              classes: {
                                root:
                                  funcionarioSelecionado &&
                                  funcionarioSelecionado.crede_elementos_ocultar_flag ==
                                    1
                                    ? classes.disabledTextField
                                    : null, // Apply the disabledTextField class to the root element
                                input:
                                  funcionarioSelecionado &&
                                  funcionarioSelecionado.crede_elementos_ocultar_flag ==
                                    1
                                    ? classes.blurredText
                                    : null, // Apply the blurred text class to the input element
                              },
                            }}
                          />
                        </Box>
                      </Box>
                      {/* <Box sx={{ m: 1 }}>
                  <Typography
                    style={{ fontWeight: "bold", marginBottom: "10px" }}
                  >
                    Email
                  </Typography>
                  <TextField
                    disabled
                    name="email"
                    size="small"
                    variant="outlined"
                    value={funcionarioSel.email}
                    onChange={handleChange}
                    style={{ width: "100%" }}
                  />
                </Box> */}
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        width: "48%",
                      }}
                    >
                      {/* <Box sx={{ display: "flex", flexDirection: "column", m: 1 }}>
                  <LocalizationProvider
                    dateAdapter={AdapterDateFns}
                    locale={ptLocale}
                  >
                    <Typography
                      style={{ fontWeight: "bold", marginBottom: "10px" }}
                    >
                      Data de Nascimento
                    </Typography>
                    <DatePicker
                      disabled
                      margin="normal"
                      id="date-picker-dialog"
                      format="dd/MM/yyyy"
                      okLabel="ok"
                      cancelLabel="cancelar"
                      invalidDateMessage="Data Inválida"
                      value={dataNascimento}
                      onChange={handleDataNascimentoChange}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          inputProps={{
                            ...params.inputProps,
                            placeholder: "dd/mm/aaaa",
                          }}
                          InputProps={{
                            ...params.InputProps,
                            disableUnderline: true,
                          }}
                          name="data_nascimento"
                          sx={{ width: "200px" }}
                          variant="outlined"
                          size="small"
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Box> */}
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        {/* <Box sx={{ m: 1, width: "46.5%" }}>
                    <Typography
                      style={{ fontWeight: "bold", marginBottom: "10px" }}
                    >
                      Local de nascimento
                    </Typography>
                    <TextField
                      disabled
                      name="local_nascimento"
                      size="small"
                      variant="outlined"
                      value={funcionarioSel.local_nascimento}
                      onChange={handleChange}
                      style={{ width: "100%" }}
                    />
                  </Box> */}
                        <Box sx={{ m: 1, width: "46.5%" }}>
                          <Typography
                            style={{ fontWeight: "bold", marginBottom: "10px" }}
                          >
                            Nacionalidade
                          </Typography>
                          <TextField
                            disabled
                            name="nacionalidade"
                            size="small"
                            variant="outlined"
                            value={funcionarioSel.nacionalidade}
                            onChange={handleChange}
                            style={{ width: "100%" }}
                            className={
                              funcionarioSelecionado &&
                              funcionarioSelecionado.crede_elementos_ocultar_flag ==
                                1
                                ? classes.textField
                                : null
                            }
                            InputProps={{
                              readOnly: true, // Make the TextField read-only
                              classes: {
                                root:
                                  funcionarioSelecionado &&
                                  funcionarioSelecionado.crede_elementos_ocultar_flag ==
                                    1
                                    ? classes.disabledTextField
                                    : null, // Apply the disabledTextField class to the root element
                                input:
                                  funcionarioSelecionado &&
                                  funcionarioSelecionado.crede_elementos_ocultar_flag ==
                                    1
                                    ? classes.blurredText
                                    : null, // Apply the blurred text class to the input element
                              },
                            }}
                          />
                        </Box>
                        <Box sx={{ m: 1, width: "46.5%" }}>
                          <Typography
                            style={{ fontWeight: "bold", marginBottom: "10px" }}
                          >
                            Entidade Patronal
                          </Typography>
                          <Autocomplete
                            disabled
                            fullWidth
                            clearText="Limpar"
                            openText="Abrir"
                            closeText="Fechar"
                            noOptionsText="Sem dados"
                            options={empresas || []}
                            value={empresa}
                            getOptionLabel={(option) =>
                              `${option.descricao}` || ""
                            }
                            isOptionEqualToValue={(option, value) => {
                              // if (!value.id) return true;
                              return value.id === option.id;
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                size="small"
                                variant="outlined"
                                className={
                                  funcionarioSelecionado &&
                                  funcionarioSelecionado.crede_elementos_ocultar_flag ==
                                    1
                                    ? classes.textField
                                    : null
                                }
                                InputProps={{
                                  readOnly: true, // Make the TextField read-only
                                  classes: {
                                    root:
                                      funcionarioSelecionado &&
                                      funcionarioSelecionado.crede_elementos_ocultar_flag ==
                                        1
                                        ? classes.disabledTextField
                                        : null, // Apply the disabledTextField class to the root element
                                    input:
                                      funcionarioSelecionado &&
                                      funcionarioSelecionado.crede_elementos_ocultar_flag ==
                                        1
                                        ? classes.blurredText
                                        : null, // Apply the blurred text class to the input element
                                  },
                                }}
                              />
                            )}
                            onChange={(_, value, reason) => {
                              if (reason === "clear") {
                                setEmpresa(null);
                                return;
                              } else {
                                setEmpresa(value);
                                return value;
                              }
                            }}
                          />
                        </Box>
                      </Box>
                      {/* <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Box sx={{ m: 1, width: "46.5%" }}>
                    <Typography
                      style={{ fontWeight: "bold", marginBottom: "10px" }}
                    >
                      Filiação - Pai
                    </Typography>
                    <TextField
                      disabled
                      name="filiacao_pai"
                      size="small"
                      variant="outlined"
                      value={funcionarioSel.filiacao_pai}
                      onChange={handleChange}
                      style={{ width: "100%" }}
                    />
                  </Box>
                  <Box sx={{ m: 1, width: "46.5%" }}>
                    <Typography
                      style={{ fontWeight: "bold", marginBottom: "10px" }}
                    >
                      Filiação - Mãe
                    </Typography>
                    <TextField
                      disabled
                      name="filiacao_mae"
                      size="small"
                      variant="outlined"
                      value={funcionarioSel.filiacao_mae}
                      onChange={handleChange}
                      style={{ width: "100%" }}
                    />
                  </Box>
                </Box>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Box sx={{ m: 1, width: "46.5%" }}>
                    <Typography
                      style={{ fontWeight: "bold", marginBottom: "10px" }}
                    >
                      Categoria Profissional
                    </Typography>
                    <TextField
                      disabled
                      name="categoria_profissional"
                      size="small"
                      variant="outlined"
                      value={funcionarioSel.categoria_profissional}
                      onChange={handleChange}
                      style={{ width: "100%" }}
                    />
                  </Box>
                  <Box sx={{ m: 1, width: "46.5%" }}>
                    <Typography
                      style={{ fontWeight: "bold", marginBottom: "10px" }}
                    >
                      Função
                    </Typography>
                    <TextField
                      disabled
                      name="funcao"
                      size="small"
                      variant="outlined"
                      value={funcionarioSel.funcao}
                      onChange={handleChange}
                      style={{ width: "100%" }}
                    />
                  </Box>
                </Box> */}
                      {/* <Box sx={{ display: "flex", justifyContent: "space-between" }}> */}
                      {/* <Box sx={{ m: 1, width: "46.5%" }}>
                    <Typography
                      style={{ fontWeight: "bold", marginBottom: "10px" }}
                    >
                      Habilitações
                    </Typography>
                    <Autocomplete
                      disabled
                      fullWidth
                      clearText="Limpar"
                      openText="Abrir"
                      closeText="Fechar"
                      noOptionsText="Sem dados"
                      options={habilitacoes || []}
                      value={habilitacao}
                      getOptionLabel={(option) => `${option.descricao}` || ""}
                      isOptionEqualToValue={(option, value) => {
                        // if (!value.id) return true;
                        return value.id === option.id;
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          size="small"
                          variant="outlined"
                        />
                      )}
                      onChange={(_, value, reason) => {
                        if (reason === "clear") {
                          setHabilitacao(null);
                          return;
                        } else {
                          setHabilitacao(value);
                          return value;
                        }
                      }}
                    />
                  </Box> */}
                      {/* </Box> */}
                      <Box sx={{ m: 1 }}>
                        <h4
                          style={{ color: "#E21450" }}
                          className="text-underline-title-drawer "
                        >
                          Documento de Identificação
                        </h4>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <Box sx={{ m: 1, width: "46.5%" }}>
                              <Typography
                                style={{
                                  fontWeight: "bold",
                                  marginBottom: "10px",
                                }}
                              >
                                Tipo de Documento
                              </Typography>
                              <Autocomplete
                                disabled
                                fullWidth
                                clearText="Limpar"
                                openText="Abrir"
                                closeText="Fechar"
                                noOptionsText="Sem dados"
                                options={tipoDocs || []}
                                value={tipoDoc}
                                getOptionLabel={(option) =>
                                  `${option.descricao}` || ""
                                }
                                isOptionEqualToValue={(option, value) => {
                                  // if (!value.id) return true;
                                  return value.id === option.id;
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    size="small"
                                    variant="outlined"
                                    className={
                                      funcionarioSelecionado &&
                                      funcionarioSelecionado.crede_elementos_ocultar_flag ==
                                        1
                                        ? classes.textField
                                        : null
                                    }
                                    InputProps={{
                                      readOnly: true, // Make the TextField read-only
                                      classes: {
                                        root:
                                          funcionarioSelecionado &&
                                          funcionarioSelecionado.crede_elementos_ocultar_flag ==
                                            1
                                            ? classes.disabledTextField
                                            : null, // Apply the disabledTextField class to the root element
                                        input:
                                          funcionarioSelecionado &&
                                          funcionarioSelecionado.crede_elementos_ocultar_flag ==
                                            1
                                            ? classes.blurredText
                                            : null, // Apply the blurred text class to the input element
                                      },
                                    }}
                                  />
                                )}
                                onChange={(_, value, reason) => {
                                  if (reason === "clear") {
                                    setTipoDoc(null);
                                    return;
                                  } else {
                                    setTipoDoc(value);
                                    return value;
                                  }
                                }}
                              />
                            </Box>
                            <Box sx={{ m: 1, width: "46.5%" }}>
                              <Typography
                                style={{
                                  fontWeight: "bold",
                                  marginBottom: "10px",
                                }}
                              >
                                Nº Doc Identificação
                              </Typography>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <TextField
                                  disabled
                                  name="doc_nr_identificacao"
                                  size="small"
                                  variant="outlined"
                                  value={funcionarioSel.doc_nr_identificacao}
                                  onChange={handleChange}
                                  style={{ width: "69%" }}
                                  className={
                                    funcionarioSelecionado &&
                                    funcionarioSelecionado.crede_elementos_ocultar_flag ==
                                      1
                                      ? classes.textField
                                      : null
                                  }
                                  InputProps={{
                                    readOnly: true, // Make the TextField read-only
                                    classes: {
                                      root:
                                        funcionarioSelecionado &&
                                        funcionarioSelecionado.crede_elementos_ocultar_flag ==
                                          1
                                          ? classes.disabledTextField
                                          : null, // Apply the disabledTextField class to the root element
                                      input:
                                        funcionarioSelecionado &&
                                        funcionarioSelecionado.crede_elementos_ocultar_flag ==
                                          1
                                          ? classes.blurredText
                                          : null, // Apply the blurred text class to the input element
                                    },
                                  }}
                                />
                                <TextField
                                  disabled
                                  name="doc_nr_identificacao_controlo"
                                  size="small"
                                  variant="outlined"
                                  value={
                                    funcionarioSel.doc_nr_identificacao_controlo
                                  }
                                  onChange={handleChange}
                                  style={{ width: "29%" }}
                                  className={
                                    funcionarioSelecionado &&
                                    funcionarioSelecionado.crede_elementos_ocultar_flag ==
                                      1
                                      ? classes.textField
                                      : null
                                  }
                                  InputProps={{
                                    readOnly: true, // Make the TextField read-only
                                    classes: {
                                      root:
                                        funcionarioSelecionado &&
                                        funcionarioSelecionado.crede_elementos_ocultar_flag ==
                                          1
                                          ? classes.disabledTextField
                                          : null, // Apply the disabledTextField class to the root element
                                      input:
                                        funcionarioSelecionado &&
                                        funcionarioSelecionado.crede_elementos_ocultar_flag ==
                                          1
                                          ? classes.blurredText
                                          : null, // Apply the blurred text class to the input element
                                    },
                                  }}
                                />
                              </Box>
                            </Box>
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                m: 1,
                                width: "46.5%",
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  width: "45%",
                                }}
                              >
                                <LocalizationProvider
                                  dateAdapter={AdapterDateFns}
                                  locale={ptLocale}
                                >
                                  <Typography
                                    style={{
                                      fontWeight: "bold",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    Data de Validade
                                  </Typography>
                                  <DatePicker
                                    disabled
                                    margin="normal"
                                    id="date-picker-dialog"
                                    format="dd/MM/yyyy"
                                    okLabel="ok"
                                    cancelLabel="cancelar"
                                    invalidDateMessage="Data Inválida"
                                    value={dataValidade}
                                    onChange={handleDataValidadeChange}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        inputProps={{
                                          ...params.inputProps,
                                          placeholder: "dd/mm/aaaa",
                                        }}
                                        InputProps={{
                                          ...params.InputProps,
                                          disableUnderline: true,
                                        }}
                                        variant="outlined"
                                        size="small"
                                        className={
                                          funcionarioSelecionado &&
                                          funcionarioSelecionado.crede_elementos_ocultar_flag ==
                                            1
                                            ? classes.textField
                                            : null
                                        }
                                      />
                                    )}
                                    InputProps={{
                                      readOnly: true, // Make the TextField read-only
                                      classes: {
                                        root:
                                          funcionarioSelecionado &&
                                          funcionarioSelecionado.crede_elementos_ocultar_flag ==
                                            1
                                            ? classes.disabledTextField
                                            : null, // Apply the disabledTextField class to the root element
                                        input:
                                          funcionarioSelecionado &&
                                          funcionarioSelecionado.crede_elementos_ocultar_flag ==
                                            1
                                            ? classes.blurredText
                                            : null, // Apply the blurred text class to the input element
                                      },
                                    }}
                                  />
                                </LocalizationProvider>
                              </Box>
                              <Box
                                sx={{
                                  display: "flex-end",
                                  flexDirection: "column",
                                  width: "45%",
                                }}
                              >
                                <LocalizationProvider
                                  dateAdapter={AdapterDateFns}
                                  locale={ptLocale}
                                >
                                  <Typography
                                    style={{
                                      fontWeight: "bold",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    Data de Emissão
                                  </Typography>
                                  <DatePicker
                                    disabled
                                    margin="normal"
                                    id="date-picker-dialog"
                                    format="dd/MM/yyyy"
                                    okLabel="ok"
                                    cancelLabel="cancelar"
                                    invalidDateMessage="Data Inválida"
                                    value={dataEmissao}
                                    onChange={handleDataEmissaoChange}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        inputProps={{
                                          ...params.inputProps,
                                          placeholder: "dd/mm/aaaa",
                                        }}
                                        InputProps={{
                                          ...params.InputProps,
                                          disableUnderline: true,
                                        }}
                                        variant="outlined"
                                        size="small"
                                        className={
                                          funcionarioSelecionado &&
                                          funcionarioSelecionado.crede_elementos_ocultar_flag ==
                                            1
                                            ? classes.textField
                                            : null
                                        }
                                      />
                                    )}
                                    InputProps={{
                                      readOnly: true, // Make the TextField read-only
                                      classes: {
                                        root:
                                          funcionarioSelecionado &&
                                          funcionarioSelecionado.crede_elementos_ocultar_flag ==
                                            1
                                            ? classes.disabledTextField
                                            : null, // Apply the disabledTextField class to the root element
                                        input:
                                          funcionarioSelecionado &&
                                          funcionarioSelecionado.crede_elementos_ocultar_flag ==
                                            1
                                            ? classes.blurredText
                                            : null, // Apply the blurred text class to the input element
                                      },
                                    }}
                                  />
                                </LocalizationProvider>
                              </Box>
                            </Box>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                m: 1,
                                width: "46.5%",
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex-end",
                                  flexDirection: "column",
                                }}
                              >
                                <Typography
                                  style={{
                                    fontWeight: "bold",
                                    marginBottom: "10px",
                                  }}
                                >
                                  Vitalicio
                                </Typography>
                                <Box>
                                  <Checkbox
                                    disabled
                                    checked={vitalicio}
                                    onChange={() => setVitalicio(!vitalicio)}
                                  />
                                </Box>
                              </Box>
                            </Box>
                          </Box>
                        </Box>
                        {/* <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      width: "48%",
                    }}
                  >
                    <Box sx={{ m: 1 }}>
                      <Typography
                        style={{ fontWeight: "bold", marginBottom: "10px" }}
                      >
                        NIF
                      </Typography>
                      <TextField
                        disabled
                        name="nif"
                        size="small"
                        variant="outlined"
                        value={funcionarioSel.nif}
                        onChange={handleChange}
                        style={{ width: "100%" }}
                      />
                    </Box>
                    <Box sx={{ m: 1 }}>
                      <Typography
                        style={{ fontWeight: "bold", marginBottom: "10px" }}
                      >
                        Entidade Emissora
                      </Typography>
                      <TextField
                        name="doc_entidade_emissora"
                        size="small"
                        disabled
                        variant="outlined"
                        value={funcionarioSel.doc_entidade_emissora}
                        onChange={handleChange}
                        style={{ width: "100%" }}
                      />
                    </Box>
                  </Box> */}
                      </Box>
                    </Box>
                  </Box>

                  {/* <Box
              sx={{ display: "flex", justifyContent: "space-between", mx: 1 }}
            >
              <Box
                sx={{
                  mx: 1,
                  width: "100%",
                }}
              >
                <MUIDataTable
                  data={formacoes || []}
                  title={
                    <h4
                      style={{
                        fontSize: "22px",
                        width: "100%",
                      }}
                      className="text-underline"
                    >
                      Formações
                    </h4>
                  }
                  columns={columns}
                  options={options}
                />
              </Box>
            </Box> */}
                </Card>
              </Collapse>
            </>
          )}
        <Box sx={{ m: 2 }}>
          <h4
            style={{ color: "#E21450" }}
            className="text-underline-title-drawer "
          >
            Entidade Requisitante
          </h4>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "space-between", mx: 1 }}>
          <Box sx={{ display: "flex", flexDirection: "column", width: "48%" }}>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              {/* <Box sx={{ m: 1, width: "48%" }}>
                <Typography
                  style={{ fontWeight: "bold", marginBottom: "10px" }}
                >
                  Nº Pedido no Sistema Externo
                </Typography>
                <TextField
                  name="pedido_nr"
                  size="small"
                  variant="outlined"
                  value={credenciacao.pedido_nr}
                  onChange={handleChange}
                  style={{ width: "100%" }}
                />
              </Box> */}
              <Box sx={{ m: 1, width: "48%" }}>
                <Typography
                  style={{ fontWeight: "bold", marginBottom: "10px" }}
                >
                  Acompanhante *
                </Typography>
                <Autocomplete
                  fullWidth
                  disabled={!superuser && estado.id != 1 ? true : false}
                  name="nome"
                  clearText="Limpar"
                  openText="Abrir"
                  closeText="Fechar"
                  noOptionsText="Sem dados"
                  value={acompanhante}
                  className="unidadesId-form"
                  options={filteredAcompanhantes || []}
                  getOptionLabel={(option) =>
                    `${option.numero} - ${option.nome}` || ""
                  }
                  isOptionEqualToValue={(option, value) => {
                    // if (!value.id) return true;
                    return value.id === option.id;
                  }}
                  style={{ width: "100%" }}
                  renderInput={(params) => (
                    <TextField {...params} size="small" variant="outlined" />
                  )}
                  onChange={(_, value, reason) => {
                    if (reason === "clear") {
                      setAcompanhante({
                        id: null,
                        nome: "",
                        aeroporto: "",
                        numero: "",
                      });
                    } else {
                      setAcompanhante(value);
                      dispatch(GetCredAcompanhanteById(value.id));
                    }
                    return value;
                  }}
                />
              </Box>
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Box
                  sx={{
                    m: 1,
                    display: "flex",
                    width: "46.5%",
                    flexDirection: "column",
                  }}
                >
                  <Typography
                    style={{ fontWeight: "bold", marginBottom: "10px" }}
                  >
                    Cópia Cred. Externa
                  </Typography>
                  <Box sx={{ display: "flex" }}>
                    {uploadedCopiaExterna && (
                      <Button
                        sx={{
                          height: "40px",
                          borderRadius: "5px",
                          mr: 1,
                        }}
                        className={classes.btnUpload}
                        onClick={() => {
                          Instance()
                            .get(
                              `${BASE_URL}/credenciacoes/funcionarios/files/${uploadedCopiaExterna.id_crede_elementos_files}/download`,
                              { responseType: "blob" }
                            )
                            .then(({ data }) => {
                              const filename =
                                uploadedCopiaExterna.crede_elementos_files_path.replace(
                                  /^.*[\\/]/,
                                  ""
                                );
                              fileDownload(data, filename);
                            })
                            .catch((err) => {
                              console.log(err.response);
                              if (err.response) {
                                if (err.response === 403) {
                                  // dispatch(ShowNotification(errorMessage));
                                }
                              }
                            });
                        }}
                        disabled={!superuser && estado.id != 1 ? true : false}
                      >
                        <FeatherIcon icon="download" size={20} />
                      </Button>
                    )}
                    <Button
                      sx={{
                        height: "40px",
                        width: "200px",
                        borderRadius: "5px",
                      }}
                      onChange={(e) => handleCopiaExternaChange(e, copCred)}
                      className={classes.btnUpload}
                      disabled={!superuser && estado.id != 1 ? true : false}
                    >
                      <label
                        htmlFor={copCred.crede_elementos_files_tipos_nome_input}
                        className="custom-file-upload"
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "start",
                            cursor: "pointer",
                          }}
                        >
                          <p> Carregar Ficheiro</p>
                        </div>
                      </label>
                      <input
                        type="file"
                        name={copCred.crede_elementos_files_tipos_nome_input}
                        id={copCred.crede_elementos_files_tipos_nome_input}
                        hidden
                        accept=".pdf"
                      />
                    </Button>
                    <div style={{ width: "auto" }}>
                      {copiaCredenciacaoExterna &&
                        copiaCredenciacaoExterna.map(
                          (copiaCredenciacaoExterna, index) => {
                            return (
                              <div
                                style={{
                                  // marginRight: "10px",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                                key={index}
                              >
                                {/* {copiaCredenciacao.file.name} */}
                                <IconButton
                                  onClick={() => {
                                    const fileName =
                                      copiaCredenciacaoExterna.file.name;
                                    const fileExtension = fileName.slice(
                                      (Math.max(0, fileName.lastIndexOf(".")) ||
                                        Infinity) + 1
                                    );

                                    if (fileExtension == "pdf") {
                                      const pdfFile =
                                        copiaCredenciacaoExterna.file;

                                      // Create a Blob from the PDF file
                                      const blob = new Blob([pdfFile], {
                                        type: "application/pdf",
                                      });

                                      // Create a URL for the Blob
                                      const blobUrl = URL.createObjectURL(blob);

                                      // Now you can use `blobUrl` to open or display the PDF
                                      window.open(blobUrl, "_blank");
                                    } else {
                                      const blobUrl = URL.createObjectURL(
                                        copiaCredenciacaoExterna.file
                                      );

                                      // Now you can use `blobUrl` to open or display the PDF
                                      window.open(blobUrl, "_blank");
                                    }
                                  }}
                                >
                                  <FeatherIcon icon="eye" size={"1rem"} />
                                </IconButton>
                                <IconButton
                                  onClick={(e) =>
                                    handleRemoveCopiaExterna(
                                      e,
                                      copiaCredenciacaoExterna
                                    )
                                  }
                                >
                                  <FeatherIcon icon="trash-2" size={"1rem"} />
                                </IconButton>
                              </div>
                            );
                          }
                        )}
                    </div>
                  </Box>
                </Box>
                <Box
                  sx={{
                    m: 1,
                    display: "flex",
                    width: "46.5%",
                    flexDirection: "column",
                  }}
                >
                  <Typography
                    style={{ fontWeight: "bold", marginBottom: "10px" }}
                  >
                    Nº Cartão Externo
                  </Typography>
                  <TextField
                    disabled={!superuser && estado.id != 1 ? true : false}
                    name="numero_cred_externa"
                    size="small"
                    variant="outlined"
                    value={credenciacao.numero_cred_externa}
                    onChange={handleChange}
                    style={{ width: "100%" }}
                    autoComplete="off"
                  />
                </Box>
              </Box>
            </Box>
            {acompanhante.id && (
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Box sx={{ m: 1, width: "48%" }}>
                  <Typography
                    style={{ fontWeight: "bold", marginBottom: "10px" }}
                  >
                    Entidade
                  </Typography>
                  <TextField
                    disabled
                    size="small"
                    value={acompanhanteSelecionado.entidade}
                    sx={{ width: "100%" }}
                  />
                </Box>
                <Box sx={{ m: 1, width: "23%" }}>
                  <Typography
                    style={{ fontWeight: "bold", marginBottom: "10px" }}
                  >
                    Nº Cartão
                  </Typography>
                  <TextField
                    disabled
                    size="small"
                    value={
                      acompanhanteSelecionado.crede_elementos_credenciacao_numero
                    }
                    sx={{ width: "100%" }}
                  />
                </Box>
                <Box sx={{ m: 1, width: "23%" }}>
                  <Typography
                    style={{ fontWeight: "bold", marginBottom: "10px" }}
                  >
                    Validade
                  </Typography>
                  <TextField
                    disabled
                    size="small"
                    value={moment(
                      acompanhanteSelecionado.crede_elementos_credenciacao_validade_fim
                    ).format("DD-MM-YYYY")}
                    sx={{ width: "100%" }}
                  />
                </Box>
              </Box>
            )}
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Box sx={{ m: 1, width: "48%" }}>
                <Typography
                  style={{ fontWeight: "bold", marginBottom: "10px" }}
                >
                  Motivo *
                </Typography>
                <Autocomplete
                  disabled={!superuser && estado.id != 1 ? true : false}
                  fullWidth
                  name="nome"
                  clearText="Limpar"
                  openText="Abrir"
                  closeText="Fechar"
                  noOptionsText="Sem dados"
                  value={motivo}
                  className="unidadesId-form"
                  options={motivos || []}
                  getOptionLabel={(option) => `${option.descricao}` || ""}
                  isOptionEqualToValue={(option, value) => {
                    // if (!value.id) return true;
                    return value.id === option.id;
                  }}
                  style={{ width: "100%" }}
                  renderInput={(params) => (
                    <TextField {...params} size="small" variant="outlined" />
                  )}
                  onChange={(_, value, reason) => {
                    if (reason === "clear") {
                      setMotivo({ id: null, nome: "" });
                    } else {
                      setMotivo(value);
                    }
                    return value;
                  }}
                />
              </Box>
              <Box sx={{ m: 1, width: "48%" }}>
                <Typography
                  style={{ fontWeight: "bold", marginBottom: "10px" }}
                >
                  Local/Aeroporto *
                </Typography>
                <Autocomplete
                  disabled={funcionario.id != null ? false : true}
                  fullWidth
                  clearText="Limpar"
                  openText="Abrir"
                  closeText="Fechar"
                  noOptionsText="Sem dados"
                  options={aeroportos || []}
                  value={aeroporto}
                  getOptionLabel={(option) => `${option.descricao}` || ""}
                  isOptionEqualToValue={(option, value) => {
                    // if (!value.id) return true;
                    return value.id === option.id;
                  }}
                  renderInput={(params) => (
                    <TextField {...params} size="small" variant="outlined" />
                  )}
                  onChange={(_, value, reason) => {
                    if (reason === "clear") {
                      setAeroporto({ id: null, descricao: "" });
                    } else {
                      setAeroporto(value);
                    }
                    return value;
                  }}
                />
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                my: 1,
                alignItems: "center",
              }}
            >
              <Box>
                <Checkbox checked={tools} onChange={() => setTools(!tools)} />
              </Box>
              <Typography style={{ fontWeight: "bold" }}>
                Com Ferramentas
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                my: 1,
                alignItems: "center",
              }}
            >
              <Box>
                <Checkbox
                  disabled={!superuser && estado.id != 1 ? true : false}
                  checked={carAccess}
                  onChange={() => setCarAccess(!carAccess)}
                />
              </Box>
              <Typography style={{ fontWeight: "bold" }}>
                Acesso com Viatura
              </Typography>
            </Box>
            {carAccess && (
              <>
                <Box
                  sx={{
                    m: 1,
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <Box sx={{ width: "49%" }}>
                    <Typography
                      style={{ fontWeight: "bold", marginBottom: "10px" }}
                    >
                      Matricula
                    </Typography>
                    <Autocomplete
                      disabled={!superuser && estado.id != 1 ? true : false}
                      fullWidth
                      name="nome"
                      clearText="Limpar"
                      openText="Abrir"
                      closeText="Fechar"
                      noOptionsText="Sem dados"
                      value={veiculo}
                      className="unidadesId-form"
                      options={veiculos || []}
                      getOptionLabel={(option) => `${option.descricao}` || ""}
                      isOptionEqualToValue={(option, value) => {
                        // if (!value.id) return true;
                        return value.id === option.id;
                      }}
                      style={{ width: "100%" }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          size="small"
                          variant="outlined"
                        />
                      )}
                      onChange={(_, value, reason) => {
                        if (reason === "clear") {
                          setVeiculo({ id: null, descricao: "" });
                        } else {
                          setVeiculo(value);
                        }
                        return value;
                      }}
                    />
                  </Box>

                  <Box sx={{ width: "49%" }}>
                    <Typography
                      style={{ fontWeight: "bold", marginBottom: "10px" }}
                    >
                      Portaria de Acesso
                    </Typography>
                    <Autocomplete
                      disabled={!superuser && estado.id != 1 ? true : false}
                      fullWidth
                      clearText="Limpar"
                      openText="Abrir"
                      closeText="Fechar"
                      noOptionsText="Sem dados"
                      options={portariaAcesso || []}
                      value={portAcesso}
                      getOptionLabel={(option) => `${option.descricao}` || ""}
                      isOptionEqualToValue={(option, value) => {
                        // if (!value.id) return true;
                        return value.id === option.id;
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          size="small"
                          variant="outlined"
                        />
                      )}
                      onChange={(_, value, reason) => {
                        if (reason === "clear") {
                          setPortAcesso({ id: null, descricao: "" });
                        } else {
                          setPortAcesso(value);
                        }
                        return value;
                      }}
                    />
                  </Box>
                </Box>

                {/* <Box
                  sx={{
                    display: "flex",
                    width: "100%",
                  }}
                >
                  {ficheirosState &&
                    ficheirosState.map((ficheiro, index) => {
                      const matchingFile = uploadedFiles.find(
                        (file) =>
                          file.id_crede_elementos_files_tipos ===
                          ficheiro.id_crede_elementos_files_tipos
                      );
                      return (
                        <Box sx={{ m: 1, width: "50%" }}>
                          <Typography
                            style={{ fontWeight: "bold", marginBottom: "10px" }}
                          >
                            {ficheiro.crede_elementos_files_tipos_nome}
                          </Typography>
                          <Box sx={{ display: "flex" }}>
                            {matchingFile && (
                              <Button
                                sx={{
                                  height: "40px",
                                  borderRadius: "5px",
                                  mr: 1,
                                }}
                                className={classes.btnUpload}
                                onClick={() => {
                                  Instance()
                                    .get(
                                      `${BASE_URL}/credenciacoes/funcionarios/files/${matchingFile.id_crede_elementos_files}/download`,
                                      { responseType: "blob" }
                                    )
                                    .then(({ data }) => {
                                      const filename =
                                        matchingFile.crede_elementos_files_path.replace(
                                          /^.*[\\/]/,
                                          ""
                                        );
                                      fileDownload(data, filename);
                                    })
                                    .catch((err) => {
                                      console.log(err.response);
                                      if (err.response) {
                                        if (err.response === 403) {
                                          // dispatch(ShowNotification(errorMessage));
                                        }
                                      }
                                    });
                                }}
                              >
                                <FeatherIcon icon="download" size={20} />
                              </Button>
                            )}
                            <Button
                              sx={{
                                height: "40px",
                                width: "200px",
                                borderRadius: "5px",
                                mr: 2,
                              }}
                              onChange={(e) =>
                                handleFilesChange(e, index, ficheiro)
                              }
                              className={classes.btnUpload}
                              disabled={
                                !superuser && estado.id != 1 ? true : false
                              }
                            >
                              <label
                                htmlFor={
                                  ficheiro.crede_elementos_files_tipos_nome_input
                                }
                                className="custom-file-upload"
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "start",
                                    cursor: "pointer",
                                  }}
                                >
                                  <p>Carregar Ficheiro</p>
                                </div>
                              </label>
                              <input
                                type="file"
                                name={
                                  ficheiro.crede_elementos_files_tipos_nome_input
                                }
                                id={
                                  ficheiro.crede_elementos_files_tipos_nome_input
                                }
                                hidden
                                accept="image/jpeg, .pdf"
                              />
                            </Button>
                            <div style={{ width: "auto" }}>
                              {ficheiros[index] && (
                                <div
                                  style={{
                                    // marginRight: "10px",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                  key={index}
                                >
                                  {/* {ficheiros[index].file.name} */}
                {/* <IconButton
                                    onClick={() => {
                                      const fileName =
                                        ficheiros[index].file.name;
                                      const fileExtension = fileName.slice(
                                        (Math.max(
                                          0,
                                          fileName.lastIndexOf(".")
                                        ) || Infinity) + 1
                                      );

                                      if (fileExtension == "pdf") {
                                        const pdfFile = ficheiros[index].file;

                                        // Create a Blob from the PDF file
                                        const blob = new Blob([pdfFile], {
                                          type: "application/pdf",
                                        });

                                        // Create a URL for the Blob
                                        const blobUrl =
                                          URL.createObjectURL(blob);

                                        // Now you can use `blobUrl` to open or display the PDF
                                        window.open(blobUrl, "_blank");
                                      } else {
                                        const blobUrl = URL.createObjectURL(
                                          ficheiros[index].file
                                        );

                                        // Now you can use `blobUrl` to open or display the PDF
                                        window.open(blobUrl, "_blank");
                                      }
                                    }}
                                  >
                                    <FeatherIcon icon="eye" size={"1rem"} />
                                  </IconButton>
                                  <IconButton
                                    onClick={(e) => handleRemoveFiles(index)}
                                  >
                                    <FeatherIcon icon="trash-2" size={"1rem"} />
                                  </IconButton>
                                </div>
                              )}
                            </div>
                          </Box>
                          {ficheiro.id_crede_elementos_files_tipos != 1 &&
                            ficheiros[index] && (
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  mt: 1,
                                }}
                              >
                                <LocalizationProvider
                                  dateAdapter={AdapterDateFns}
                                  locale={ptLocale}
                                >
                                  <Typography
                                    style={{
                                      fontWeight: "bold",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    Data de Validade
                                  </Typography>
                                  <DatePicker
                                    margin="normal"
                                    id="date-picker-dialog"
                                    format="dd/MM/yyyy"
                                    okLabel="ok"
                                    value={datePickerValues[index]}
                                    onChange={(date) =>
                                      handleDatePickerChange(date, index)
                                    }
                                    cancelLabel="cancelar"
                                    invalidDateMessage="Data Inválida"
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        inputProps={{
                                          ...params.inputProps,
                                          placeholder: "dd/mm/aaaa",
                                        }}
                                        InputProps={{
                                          ...params.InputProps,
                                          disableUnderline: true,
                                        }}
                                        name="data_nascimento"
                                        sx={{ width: "200px" }}
                                        variant="outlined"
                                        size="small"
                                      />
                                    )}
                                  />
                                </LocalizationProvider>
                              </Box>
                            )}
                        </Box>
                      );
                    })}
                </Box> */}
              </>
            )}
            {aeroporto.id == 1314 && (
              <Box sx={{ m: 1 }}>
                <Typography
                  style={{ fontWeight: "bold", marginBottom: "10px" }}
                >
                  Destinatários
                </Typography>
                <Autocomplete
                  multiple
                  disableCloseOnSelect
                  fullWidth
                  name="destinatarios"
                  clearText="Limpar"
                  openText="Abrir"
                  closeText="Fechar"
                  noOptionsText="Sem dados"
                  value={destinatarios}
                  className="unidadesId-form"
                  options={destinatariosOptions || []}
                  getOptionLabel={(option) => (
                    <>
                      {option.descricao}
                      <br />
                      {option.email}
                    </>
                  )}
                  filterOptions={filterOptions}
                  isOptionEqualToValue={(option, value) => {
                    // if (!value.id) return true;
                    return value.id === option.id;
                  }}
                  style={{ width: "100%" }}
                  renderInput={(params) => (
                    <TextField {...params} size="small" variant="outlined" />
                  )}
                  onChange={(_, value, reason) => {
                    if (reason === "clear") {
                      setDestinatarios([]);
                      return;
                    } else {
                      setDestinatarios(value);
                      return value;
                    }
                  }}
                />
              </Box>
            )}
            {/* <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Box sx={{ m: 1, width: "48%" }}>
                <Typography
                  style={{ fontWeight: "bold", marginBottom: "10px" }}
                >
                  Tipo de Cartão Solicitado
                </Typography>
                <Autocomplete
                  fullWidth
                  clearText="Limpar"
                  openText="Abrir"
                  closeText="Fechar"
                  noOptionsText="Sem dados"
                  options={tipoCartoes || []}
                  value={tipoCartao}
                  getOptionLabel={(option) => `${option.descricao}` || ""}
                  isOptionEqualToValue={(option, value) => {
                    // if (!value.id) return true;
                    return value.id === option.id;
                  }}
                  renderInput={(params) => (
                    <TextField {...params} size="small" variant="outlined" />
                  )}
                  onChange={(_, value, reason) => {
                    if (reason === "clear") {
                      setTipoCartao(null);
                      return;
                    } else {
                      setTipoCartao(value);
                      return value;
                    }
                  }}
                />
              </Box>
              <Box sx={{ m: 1, width: "48%" }}>
                <Typography
                  style={{ fontWeight: "bold", marginBottom: "10px" }}
                >
                  Função a desempenhar
                </Typography>
                <Autocomplete
                  fullWidth
                  clearText="Limpar"
                  openText="Abrir"
                  closeText="Fechar"
                  noOptionsText="Sem dados"
                  options={funcoes || []}
                  value={funcao}
                  getOptionLabel={(option) => `${option.descricao}` || ""}
                  isOptionEqualToValue={(option, value) => {
                    // if (!value.id) return true;
                    return value.id === option.id;
                  }}
                  renderInput={(params) => (
                    <TextField {...params} size="small" variant="outlined" />
                  )}
                  onChange={(_, value, reason) => {
                    if (reason === "clear") {
                      setFuncao(null);
                      return;
                    } else {
                      setFuncao(value);
                      return value;
                    }
                  }}
                />
              </Box>
            </Box> */}
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column", width: "48%" }}>
            <Box sx={{ display: "flex", flexDirection: "column", m: 1 }}>
              <LocalizationProvider
                dateAdapter={AdapterDateFns}
                locale={ptLocale}
              >
                <Typography
                  style={{ fontWeight: "bold", marginBottom: "10px" }}
                >
                  Validade de acesso
                </Typography>
                <Box sx={{ display: "flex" }}>
                  <Button
                    variant="outlined"
                    onClick={() => setOpenDates(!open)}
                    sx={{ mr: 2, minWidth: "200px", height: "40px" }}
                  >
                    Selecionar datas
                  </Button>
                  <MultipleDatesPicker
                    disabled={!superuser && estado.id != 1 ? true : false}
                    open={openDates}
                    selectedDates={datasSelected}
                    onCancel={() => setOpenDates(false)}
                    onSubmit={(dates) => {
                      const warningMessage = {
                        isOpen: true,
                        message: "Selecione datas não inferiores à de hoje",
                        type: "warning",
                      };

                      const warningMaxMessage = (max) => {
                        return {
                          isOpen: true,
                          message: `Selecione no máximo de ${max} dias consecutivos`,
                          type: "warning",
                        };
                      };

                      const warningMessageToday = {
                        isOpen: true,
                        message:
                          "Data atual selecionada, de preferência peça com 24h de antecedência",
                        type: "warning",
                      };

                      const isBeforeToday = dates.some((date) => {
                        const todayDate = new Date(
                          today.getFullYear(),
                          today.getMonth(),
                          today.getDate()
                        );
                        const checkDate = new Date(
                          date.getFullYear(),
                          date.getMonth(),
                          date.getDate()
                        );

                        return checkDate < todayDate;
                      });

                      const isToday = dates.some((date) => {
                        const todayDate = new Date(
                          today.getFullYear(),
                          today.getMonth(),
                          today.getDate()
                        );
                        const checkDate = new Date(
                          date.getFullYear(),
                          date.getMonth(),
                          date.getDate()
                        );

                        return checkDate.getTime() == todayDate.getTime();
                      });
                      if (isBeforeToday) {
                        dispatch(ShowNotification(warningMessage));
                      } else if (!checkConsecutiveDates(aeroporto.id, dates)) {
                        const maxConsecutiveDays =
                          aeroporto.id === 1313 ? 3 : 5;
                        dispatch(
                          ShowNotification(
                            warningMaxMessage(maxConsecutiveDays)
                          )
                        );
                      } else if (isToday) {
                        dispatch(ShowNotification(warningMessageToday));
                        dispatch(GetCredAcompanhantesDisponibilidade(dates));
                        handleDatesChange(dates);
                        setOpenDates(false);
                      } else {
                        dispatch(GetCredAcompanhantesDisponibilidade(dates));
                        handleDatesChange(dates);
                        setOpenDates(false);
                      }
                    }}
                    cancelButtonText="Cancelar"
                    submitButtonText="Confirmar"
                  />
                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                    }}
                  >
                    {datasSelected
                      ? datasSelected.map((date) => {
                          return (
                            <Typography
                              sx={{
                                fontWeight: "bold",
                                display: "flex",
                                alignItems: "center",
                                mx: 1,
                              }}
                            >
                              {moment(date).format("DD-MM-YYYY")}
                            </Typography>
                          );
                        })
                      : null}
                  </Box>
                </Box>
              </LocalizationProvider>
            </Box>
            <Box sx={{ m: 1 }}>
              <Typography style={{ fontWeight: "bold", marginBottom: "10px" }}>
                Área de acesso pretendido
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "space-between",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    my: 1,
                    justifyContent: "flex-start",
                    alignItems: "center",
                    width: "8%",
                  }}
                >
                  <Box>
                    <Checkbox
                      disabled={!superuser && estado.id != 1 ? true : false}
                      checked={areaA}
                      onChange={() => setAreaA(!areaA)}
                    />
                  </Box>
                  <Typography style={{ fontWeight: "bold" }}>A</Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    my: 1,
                    alignItems: "center",
                    width: "8%",
                  }}
                >
                  <Box>
                    <Checkbox
                      disabled={!superuser && estado.id != 1 ? true : false}
                      checked={areaB}
                      onChange={() => setAreaB(!areaB)}
                    />
                  </Box>
                  <Typography style={{ fontWeight: "bold" }}>B</Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    my: 1,
                    alignItems: "center",
                    width: "8%",
                  }}
                >
                  <Box>
                    <Checkbox
                      disabled={!superuser && estado.id != 1 ? true : false}
                      checked={areaC}
                      onChange={() => setAreaC(!areaC)}
                    />
                  </Box>
                  <Typography style={{ fontWeight: "bold" }}>C</Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    my: 1,
                    alignItems: "center",
                    width: "8%",
                  }}
                >
                  <Box>
                    <Checkbox
                      disabled={!superuser && estado.id != 1 ? true : false}
                      checked={areaE}
                      onChange={() => setAreaE(!areaE)}
                    />
                  </Box>
                  <Typography style={{ fontWeight: "bold" }}>E</Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    my: 1,
                    alignItems: "center",
                    width: "8%",
                  }}
                >
                  <Box>
                    <Checkbox
                      disabled={!superuser && estado.id != 1 ? true : false}
                      checked={areaI}
                      onChange={() => setAreaI(!areaI)}
                    />
                  </Box>
                  <Typography style={{ fontWeight: "bold" }}>I</Typography>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    my: 1,
                    alignItems: "center",
                    width: "8%",
                  }}
                >
                  <Box>
                    <Checkbox
                      disabled={!superuser && estado.id != 1 ? true : false}
                      checked={areaL}
                      onChange={() => setAreaL(!areaL)}
                    />
                  </Box>
                  <Typography style={{ fontWeight: "bold" }}>L</Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    my: 1,
                    alignItems: "center",
                    width: "8%",
                  }}
                >
                  <Box>
                    <Checkbox
                      disabled={!superuser && estado.id != 1 ? true : false}
                      checked={areaM}
                      onChange={() => setAreaM(!areaM)}
                    />
                  </Box>
                  <Typography style={{ fontWeight: "bold" }}>M</Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    my: 1,
                    alignItems: "center",
                    width: "8%",
                  }}
                >
                  <Box>
                    <Checkbox
                      disabled={!superuser && estado.id != 1 ? true : false}
                      checked={areaO}
                      onChange={() => setAreaO(!areaO)}
                    />
                  </Box>
                  <Typography style={{ fontWeight: "bold" }}>O</Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    my: 1,
                    alignItems: "center",
                    width: "8%",
                  }}
                >
                  <Box>
                    <Checkbox
                      disabled={!superuser && estado.id != 1 ? true : false}
                      checked={areaP}
                      onChange={() => setAreaP(!areaP)}
                    />
                  </Box>
                  <Typography style={{ fontWeight: "bold" }}>P</Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    my: 1,
                    alignItems: "center",
                    width: "8%",
                  }}
                >
                  <Box>
                    <Checkbox
                      disabled={!superuser && estado.id != 1 ? true : false}
                      checked={areaT}
                      onChange={() => setAreaT(!areaT)}
                    />
                  </Box>
                  <Typography style={{ fontWeight: "bold" }}>T</Typography>
                </Box>
              </Box>
            </Box>
            {/* <Box sx={{ m: 1 }}>
              <Typography style={{ fontWeight: "bold", marginBottom: "10px" }}>
                Inscrição adicional de acesso
              </Typography>
              <TextField
                name="inscricao_adicional"
                size="small"
                variant="outlined"
                value={credenciacao.inscricao_adicional}
                onChange={handleChange}
                style={{ width: "100%" }}
              />
            </Box> */}
            <Box sx={{ m: 1 }}>
              <Typography style={{ fontWeight: "bold", marginBottom: "10px" }}>
                Observações
              </Typography>
              <TextField
                disabled={!superuser && estado.id != 1 ? true : false}
                name="obs"
                multiline
                rows={3}
                size="small"
                variant="outlined"
                value={credenciacao.obs}
                onChange={handleChange}
                style={{ width: "100%" }}
                autoComplete="off"
              />
            </Box>
            {/* <Box sx={{ display: "flex", flexDirection: "column", m: 1 }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Typography
                  style={{ fontWeight: "bold", marginBottom: "10px" }}
                >
                  Horário de acesso
                </Typography>
                <Box sx={{ display: "flex" }}>
                  <TimePicker
                    format="hh:mm"
                    defaultValue
                    ampm={false}
                    value={horasInicial}
                    onChange={handleHorasInicialChange}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        inputProps={{
                          ...params.inputProps,
                          placeholder: "hh:mm",
                        }}
                        InputProps={{
                          ...params.InputProps,
                          disableUnderline: true,
                        }}
                        sx={{ width: "200px" }}
                        variant="outlined"
                        size="small"
                      />
                    )}
                  />
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      display: "flex",
                      alignItems: "center",
                      mx: 2,
                    }}
                  >
                    até
                  </Typography>
                  <TimePicker
                    format="hh:mm"
                    ampm={false}
                    value={horasFinal}
                    onChange={handleHorasFinalChange}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        inputProps={{
                          ...params.inputProps,
                          placeholder: "hh:mm",
                        }}
                        InputProps={{
                          ...params.InputProps,
                          disableUnderline: true,
                        }}
                        sx={{ width: "200px" }}
                        variant="outlined"
                        size="small"
                      />
                    )}
                  />
                </Box>
              </LocalizationProvider>
            </Box>
            <Box sx={{ m: 1 }}>
              <Typography style={{ fontWeight: "bold", marginBottom: "10px" }}>
                Cor
              </Typography>
              <Autocomplete
                fullWidth
                clearText="Limpar"
                openText="Abrir"
                closeText="Fechar"
                noOptionsText="Sem dados"
                options={cores || []}
                value={cor}
                getOptionLabel={(option) => `${option.descricao}` || ""}
                isOptionEqualToValue={(option, value) => {
                  // if (!value.id) return true;
                  return value.id === option.id;
                }}
                renderInput={(params) => (
                  <TextField {...params} size="small" variant="outlined" />
                )}
                onChange={(_, value, reason) => {
                  if (reason === "clear") {
                    setCor(null);
                    return;
                  } else {
                    setCor(value);
                    return value;
                  }
                }}
              />
            </Box>
            <Box sx={{ display: "flex", m: 1 }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Typography sx={{ fontWeight: "bold", width: "50%" }}>
                  Renovação do Cartão
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-start",
                    width: "50%",
                  }}
                >
                  <Checkbox
                    checked={renovacao}
                    onChange={() => setRenovacao(!renovacao)}
                  />
                </Box>
              </Box>
            </Box>
            <Box sx={{ display: "flex", m: 1 }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Typography style={{ fontWeight: "bold", width: "50%" }}>
                  Pedido de 2ª Via
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-start",
                    width: "50%",
                  }}
                >
                  <Checkbox
                    checked={pedido}
                    onChange={() => setPedido(!pedido)}
                  />
                </Box>
              </Box>
            </Box>
            <Box sx={{ display: "flex", m: 1 }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Typography style={{ fontWeight: "bold", width: "50%" }}>
                  Pedido de Alteração de Áreas
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-start",
                    width: "50%",
                  }}
                >
                  <Checkbox
                    checked={alteracao}
                    onChange={() => setAlteracao(!alteracao)}
                  />
                </Box>
              </Box>
            </Box>
            <Box sx={{ m: 1 }}>
              <Typography style={{ fontWeight: "bold", marginBottom: "10px" }}>
                Tipo de Vinculo Laboral
              </Typography>
              <Autocomplete
                fullWidth
                clearText="Limpar"
                openText="Abrir"
                closeText="Fechar"
                noOptionsText="Sem dados"
                options={tipoVinculos || []}
                value={tipoVinculo}
                getOptionLabel={(option) => `${option.descricao}` || ""}
                isOptionEqualToValue={(option, value) => {
                  // if (!value.id) return true;
                  return value.id === option.id;
                }}
                renderInput={(params) => (
                  <TextField {...params} size="small" variant="outlined" />
                )}
                onChange={(_, value, reason) => {
                  if (reason === "clear") {
                    setTipoVinculo(null);
                    return;
                  } else {
                    setTipoVinculo(value);
                    return value;
                  }
                }}
              />
            </Box>
            <Box sx={{ display: "flex" }}>
              <Box sx={{ display: "flex", flexDirection: "column", m: 1 }}>
                <LocalizationProvider
                  dateAdapter={AdapterDateFns}
                  locale={ptLocale}
                >
                  <Typography
                    style={{ fontWeight: "bold", marginBottom: "10px" }}
                  >
                    Inicio do Vinculo Laboral
                  </Typography>
                  <Box sx={{ display: "flex" }}>
                    <DatePicker
                      margin="normal"
                      id="date-picker-dialog"
                      format="dd/MM/yyyy"
                      okLabel="ok"
                      cancelLabel="cancelar"
                      invalidDateMessage="Data Inválida"
                      value={vinculoInicial}
                      onChange={handleVinculoInicialChange}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          inputProps={{
                            ...params.inputProps,
                            placeholder: "dd/mm/aaaa",
                          }}
                          InputProps={{
                            ...params.InputProps,
                            disableUnderline: true,
                          }}
                          sx={{ width: "200px" }}
                          variant="outlined"
                          size="small"
                        />
                      )}
                    />
                  </Box>
                </LocalizationProvider>
              </Box>
              <Box sx={{ display: "flex", flexDirection: "column", m: 1 }}>
                <LocalizationProvider
                  dateAdapter={AdapterDateFns}
                  locale={ptLocale}
                >
                  <Typography
                    style={{ fontWeight: "bold", marginBottom: "10px" }}
                  >
                    Fim do Vinculo Laboral
                  </Typography>
                  <Box sx={{ display: "flex" }}>
                    <DatePicker
                      margin="normal"
                      id="date-picker-dialog"
                      format="dd/MM/yyyy"
                      okLabel="ok"
                      cancelLabel="cancelar"
                      invalidDateMessage="Data Inválida"
                      value={vinculoFinal}
                      onChange={handleVinculoFinalChange}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          inputProps={{
                            ...params.inputProps,
                            placeholder: "dd/mm/aaaa",
                          }}
                          InputProps={{
                            ...params.InputProps,
                            disableUnderline: true,
                          }}
                          sx={{ width: "200px" }}
                          variant="outlined"
                          size="small"
                        />
                      )}
                    />
                  </Box>
                </LocalizationProvider>
              </Box>
            </Box> */}
          </Box>
        </Box>
        <Box sx={{ m: 2 }}>
          <h4
            style={{ color: "#E21450" }}
            className="text-underline-title-drawer "
          >
            Documentos
          </h4>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            mx: 1,
            width: "100%",
          }}
        >
          {downloadFiles &&
            downloadFiles.map((ficheiro, index) => {
              return (
                <Box sx={{ m: 1, width: "20%" }}>
                  <Typography
                    style={{ fontWeight: "bold", marginBottom: "10px" }}
                  >
                    {ficheiro.tipo}
                  </Typography>
                  <Box sx={{ display: "flex" }}>
                    <Button
                      sx={{
                        height: "40px",
                        borderRadius: "5px",
                        mr: 1,
                      }}
                      className={classes.btnUpload}
                      onClick={() => {
                        Instance()
                          .get(
                            `${BASE_URL}/credenciacoes/funcionarios/files/${ficheiro.fileId}/download`,
                            { responseType: "blob" }
                          )
                          .then(({ data }) => {
                            const filename = ficheiro.name.replace(
                              /^.*[\\/]/,
                              ""
                            );
                            fileDownload(data, filename);
                          })
                          .catch((err) => {
                            console.log(err.response);
                            if (err.response) {
                              if (err.response === 403) {
                                // dispatch(ShowNotification(errorMessage));
                              }
                            }
                          });
                      }}
                    >
                      <FeatherIcon icon="download" size={20} />
                    </Button>
                    <div style={{ width: "100%" }}>
                      {ficheiro && (
                        <Button
                          sx={{
                            height: "40px",
                            borderRadius: "5px",
                          }}
                          className={classes.btnUpload}
                          onClick={() => {
                            // Retrieve the base URL from environment variables
                            let baseUrl = BASE_URL;

                            // Remove the '/api' part from the base URL
                            if (baseUrl.endsWith("/api")) {
                              baseUrl = baseUrl.slice(0, -4); // Remove '/api'
                            }

                            // Construct the full file URL
                            const fileUrl = `${baseUrl}${ficheiro.name}`;

                            // Open the file in a new tab/window
                            window.open(fileUrl, "_blank");
                          }}
                        >
                          <FeatherIcon icon="eye" size={20} />
                        </Button>
                      )}
                    </div>
                  </Box>
                </Box>
              );
            })}
        </Box>
        {/* <Box sx={{ m: 2 }}>
          <h4
            style={{ color: "#E21450" }}
            className="text-underline-title-drawer "
          >
            Dados Complementares
          </h4>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "space-between", mx: 1 }}>
          <Box
            sx={{
              display: "flex",
              width: "auto",
              justifyContent: "flex-start",
            }}
          >
            <Box
              sx={{
                display: "flex",
                m: 1,
                alignItems: "center",
                width: "100%",
              }}
            >
              <Typography sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}>
                Check Ins
              </Typography>
              <Checkbox
                checked={checkIn}
                onChange={() => setCheckIn(!checkIn)}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                m: 1,
                alignItems: "center",
                width: "100%",
              }}
            >
              <Typography style={{ fontWeight: "bold", whiteSpace: "nowrap" }}>
                Porta Embarque
              </Typography>
              <Checkbox
                checked={portaEm}
                onChange={() => setPortaEm(!portaEm)}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                m: 1,
                alignItems: "center",
                width: "100%",
              }}
            >
              <Typography style={{ fontWeight: "bold", whiteSpace: "nowrap" }}>
                Porta de desembarque
              </Typography>

              <Checkbox
                checked={portaDes}
                onChange={() => setPortaDes(!portaDes)}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                m: 1,
                alignItems: "center",
                width: "100%",
              }}
            >
              <Typography style={{ fontWeight: "bold", whiteSpace: "nowrap" }}>
                Outras Portas
              </Typography>

              <Checkbox
                checked={outrasPortas}
                onChange={() => setOutrasPortas(!outrasPortas)}
              />
            </Box>
          </Box>
        </Box> */}
        {/* <Box sx={{ m: 2 }}>
          <h4
            style={{ color: "#E21450" }}
            className="text-underline-title-drawer "
          >
            Inquerito Pessoal
          </h4>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "space-between", mx: 1 }}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Box sx={{ display: "flex", m: 1 }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Typography
                  style={{
                    fontWeight: "bold",
                    width: "50%",
                    whiteSpace: "nowrap",
                  }}
                >
                  Inquérito Pessoal Realizado com êxito?
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-start",
                  }}
                >
                  <Checkbox
                    checked={inquerito}
                    onChange={() => setInquerito(!inquerito)}
                  />
                </Box>
              </Box>
            </Box>
            <Box sx={{ mx: 5, display: "flex", alignItems: "center" }}>
              {uploadedInquerito && (
                <Button
                  sx={{
                    height: "40px",
                    borderRadius: "5px",
                    mr: 1,
                  }}
                  className={classes.btnUpload}
                  onClick={() => {
                    Instance()
                      .get(
                        `${BASE_URL}/credenciacoes/funcionarios/files/${uploadedInquerito.id_crede_elementos_files}/download`,
                        { responseType: "blob" }
                      )
                      .then(({ data }) => {
                        const filename =
                          uploadedInquerito.crede_elementos_files_path.replace(
                            /^.*[\\\/]/,
                            ""
                          );
                        fileDownload(data, filename);
                      })
                      .catch((err) => {
                        console.log(err.response);
                        if (err.response) {
                          if (err.response === 403) {
                            // dispatch(ShowNotification(errorMessage));
                          }
                        }
                      });
                  }}
                >
                  <FeatherIcon icon="download" size={20} />
                </Button>
              )}
              <Button
                sx={{
                  height: "40px",
                  width: "300px",
                  borderRadius: "5px",
                  mr: 2,
                }}
                onChange={(e) => handleInqPessoalChange(e, inqPessoal)}
                className={classes.btnUpload}
              >
                <label
                  htmlFor={inqPessoal.crede_elementos_files_tipos_nome_input}
                  className="custom-file-upload"
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "start",
                      cursor: "pointer",
                    }}
                  >
                    <p> Carregar Ficheiro</p>
                  </div>
                </label>
                <input
                  type="file"
                  name={inqPessoal.crede_elementos_files_tipos_nome_input}
                  id={inqPessoal.crede_elementos_files_tipos_nome_input}
                  hidden
                  accept=".pdf"
                />
              </Button>
              <div style={{ width: "100%" }}>
                {inqueritoPessoal &&
                  inqueritoPessoal.map((inqueritoPessoal, index) => {
                    return (
                      <div
                        style={{
                          marginRight: "10px",
                          display: "flex",
                          alignItems: "center",
                        }}
                        key={index}
                      >
                        {inqueritoPessoal.file.name}
                        <IconButton
                          onClick={(e) =>
                            handleRemoveInquerito(e, inqueritoPessoal)
                          }
                        >
                          <FeatherIcon icon="trash-2" size={"1rem"} />
                        </IconButton>
                      </div>
                    );
                  })}
              </div>
            </Box>
            {/* <Box sx={{ mx: 5 }}>
              <Button
                sx={{
                  height: "40px",
                  width: "350px",
                  borderRadius: "5px",
                  mr: 2,
                }}
                onChange={(e) => handleInqPessoalChange(e, inqueritoPessoal)}
                className={classes.btnUpload}
              >
                <label
                  htmlFor={inqueritoPessoal.crede_elementos_files_tipos_nome_input}
                  className="custom-file-upload"
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "start",
                      cursor: "pointer",
                    }}
                  >
                    <p> Carregar Ficheiro</p>
                  </div>
                </label>
                <input
                  type="file"
                  name={inqueritoPessoal.crede_elementos_files_tipos_nome_input}
                  id={inqueritoPessoal.crede_elementos_files_tipos_nome_input}
                  hidden
                  accept=".pdf"
                />
              </Button>
              <div style={{ width: "100%" }}>
                {inqPessoal &&
                  inqPessoal.map((inqPessoal, index) => {
                    return (
                      <div
                        style={{
                          marginRight: "10px",
                          display: "flex",
                          alignItems: "center",
                        }}
                        key={index}
                      >
                        {inqPessoal.file.name}
                        <IconButton
                          onClick={(e) =>
                            handleRemoveInquerito(e, inqPessoal)
                          }
                        >
                          <FeatherIcon icon="trash-2" size={"1rem"} />
                        </IconButton>
                      </div>
                    );
                  })}
              </div>
            </Box>
          </Box>
        </Box> */}
      </Card>
    </div>
  );
};

export default FormEditPontual;
